<template>
 <div>{{ActDescBtn}}
 <table style="position: absolute;" width="100%"  :height="this.windowSize.height-96"  :max-height="this.windowSize.height-96" >
    
   <tr height="48px" max-height="48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Utilitario Recibos Ingreso'"
          :titulo="'Utilitario Recibos Ingreso'"
          @MethodAnular=""
          @MethodEliminar="remove"
          @MethodGuardar="save"
          @MethodImprimir="imprimirList"
          @MethodNuevo="newwnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        /> 
      </tr>
  <tr>
<!-- BarraPrimaria --------------------------------------------------------------------------------->
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraPrimariaAbrir">

         <div class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">
        
        <v-tooltip left>
          <template v-slot:activator="{ on }">
              <center>
              <v-btn-toggle>
                <v-btn
                  small
                  color="yellow accent-4"
                  @click.prevent="actualiza_tb_ver"
                >
                  <i style="font-size: 25px;" class="fa fa-eye"> </i> ver</v-btn
                >
                <v-btn
                  small
                  dark
                  color="deep-purple accent-2"
                  @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                >
                  <i style="font-size: 25px;" class="fa fa-print"> </i>
                  Listado</v-btn
                >
              </v-btn-toggle>
            </center>
            <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitUtilitarioRecIng'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
          </template>
        </v-tooltip>




      </div>
      </td>
<!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
<!-- contenido central ------------------------------------------------------------------------------ -->
      <td :max-height="this.windowSize.height-96" >
        <v-app id="inspire" class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">
 

 <div class="px-2">
  <v-card color="grey lighten-3">
  <div class="px-2" style="border: 1px solid #000000;">
  <v-form ref="formRecIng" @submit.prevent=""  v-model="valid" lazy-validation>
 <v-row>


<v-col cols="12" md="4" sm="4" class="py-2 my-0" >

<v-tooltip top>
<template v-slot:activator="{ on }"> 
  <v-text-field
          v-on="on"
        dense
        outlined
        type="date"  
        label="Fecha Inicial"
        v-model="busquedaRecIng.fechaInicial"
        :rules="[$rules.required]"
        placeholder=" "
        style="font-size: 12px;" 
        @input="getRecIngresos"
        v-on:input="resertPaginacion" 
         @blur="BlurDesde" 
         hide-details
        >
                <template v-slot:prepend>
                  <i style="font-size: 18px;" class="fa fa-calendar"></i>
                </template>
  </v-text-field>

 </template>
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
          <span> Aquí se registra la fecha a partir de la cual queremos la búsqueda.</span>
    </i>   
  </v-tooltip>
</v-col>

<v-col cols="12" md="4" sm="4" class="py-2 my-0" >
<v-tooltip top>
<template v-slot:activator="{ on }"> 
<v-text-field
v-on="on"
        dense
        outlined
        type="date"  
        label="Fecha Final"
        v-model="busquedaRecIng.fechaFinal"
        :rules="[$rules.required]"
        placeholder=" "
        style="font-size: 12px;" 
        @input="getRecIngresos" 
        v-on:input="resertPaginacion" 
        hide-details
        >
                <template v-slot:prepend>
                  <i style="font-size: 18px;" class="fa fa-calendar"></i>
                </template>
</v-text-field>

 </template>
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
          <span> Aquí se registra la fecha hasta donde queremos la búsqueda.</span>
    </i>   
  </v-tooltip>
</v-col>

<v-col cols="12" md="4" sm="4" class="py-2 my-0" >
<v-tooltip top>

<template v-slot:activator="{ on }"> 


<!-- Factura No --------------------------------------------------->    
                      <v-text-field
                       v-on="on"
                        label="No.Recibo:"
                        autocomplete="off"
                        dense
                        outlined
                        @keyup="KeyUpCantidad"
                        v-model.number="busquedaRecIng.NoRecibo"
                        placeholder=" "
                        style="font-size: 12px;"
                         @blur="getRecIngresos"
                         v-on:input="resertPaginacion" 
                         hide-details  >
                        <template v-slot:prepend>
                          <i style="font-size: 18px;" class="fa fa-slack"></i>
                        </template>
                      </v-text-field>
 </template>
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
          <span> Se registra el número de Recibo de Ingreso que se desea buscar.</span>
    </i>   
  </v-tooltip>

</v-col>

<!-- columna 1 -->
<v-col cols="12" md="6" sm="6" class="py-2 my-0">

<v-tooltip top>
<template v-slot:activator="{ on }"> 
  <v-combobox
      v-on="on"
            v-model="busquedaRecIng.documento"
            autocomplete="off"
            dense
            outlined
            label="Documentos:"
            :items="RDocumento"
            item-text="descripcion"
            @blur="SelctCbDocumentoBuscar"
            @focus="cargarDocumento"
            style="font-size: 13px;"
            @change="getRecIngresos"
            v-on:change="resertPaginacion"
          >
            <template v-slot:prepend>
              <i style="font-size: 20px;" class="fa fa-book"></i>
            </template>
          </v-combobox>

 </template>
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
          <span> Se registra el documento  de recibos de ingresos que se desea buscar.</span>
    </i>   
  </v-tooltip>
</v-col>
<v-col cols="12" md="6" sm="6" class="py-2 my-0" >
<v-tooltip top>
<template v-slot:activator="{ on }"> 
 <v-combobox v-on="on" id="formdisabledInput" v-model="busquedaRecIng.cliente"
                                         :items="RCliente" 
                                         autocomplete="off" dense
                                        item-text="codnom"
                                        label="cliente:" no-filter outlined
                                        style="font-size: 13px;" @blur="SelctCbClienteBuscar" @change="getRecIngresos"
                                        @focus="cargarCliente" @keyup="CbFilcliente" 
                                         v-on:change="resertPaginacion"  >

                              <template slot="item" slot-scope="item">
                                <span style="display:none;">
                                  {{ item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} `}}</span>
                                <span class="fontSize13"><b>{{ item.item.codigo }}</b> - {{item.item.nombre.trim()}}</span>
                              </template>

                              <template v-slot:selection="{ attrs, item, parent, selected }">
                                <span class="fontSize13 colorNombre"><b>{{ item.codigo }}</b> - {{ item.nombre }}</span>
                              </template>

                              <template v-slot:prepend>
                                <i class="fa fa-user-circle" style="font-size: 20px;"></i>
                              </template>

                            </v-combobox>
 </template>
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
          <span> Se selecciona el cliente que deseamos filtrar en la búsqueda.</span>
    </i>   
  </v-tooltip>



</v-col>
<!-- fn columna 1 -->


              </v-row>
  </v-form>
<v-col cols="12" md="12" sm="12" style="margin-top:-25px;" >
  <div style="border: 1px solid #000000;" >

<!-- @click:row="datostabla" -->
 <v-data-table
      class="RowSelectColor"
      :single-select="true"
      item-key="indx"
      :show-select="true"
       v-model="selected"
       @item-selected="obtenerDatoSelect"

      :headers="[{ text: 'Fecha', sortable: true,  value: 'fecha', width: 129 },
                 { text: 'Documento', sortable: false, value: 'documentocxc.descripcion', width:200 },
                 { text: 'Recibos', sortable: true, value: 'recibosdeingresoPK.secuencia', width:129 },
                 { text: 'Cliente', sortable: true, value: 'cliente.nombre', width:300 },
                 { text: 'Concepto', sortable: true, value: 'concepto', width:310  }
                 ]"
              dense
              :items="ListItems"
              :search="search"      
              @click:row="datostablaSelect"
              @pagination="cargarPaginacion"
              :items-per-page="TbPaginator.itemsPerPage"
              :server-items-length="TbTotalItem"
              v-if="resertPagi==true" 

            >


            <template v-slot:item.action="{ item }"> 
<!-- { text: 'Acción', sortable: false, value: 'action', width:'auto' }, -->
<v-btn fab @click.prevent="VerReporte(item)" x-small color="yellow accent-4"><i style="font-size: 20px;" class="fa fa-eye"></i></v-btn> 
<!-- <v-btn fab @click.prevent="deleFact(item)" x-small color="red darken-3"><i style="font-size: 20px;" class="fa fa-trash-o"></i></v-btn> -->
               
   </template>

              <template v-slot:item.cliente.contrato="props">
                <span v-if="props.item.cliente.contrato==true" >Si</span>
                <span v-if="props.item.cliente.contrato==false" >No</span>
              </template>

              <template v-slot:item.fecha="props">
<span style="font-size:13px; display:none;">{{props.item.indx = ListItems.indexOf(props.item)}}</span>
  
                <span>{{ FormatoFecha(props.item.fecha) }}</span>
              </template>

              <template v-slot:item.documentocxc.descripcion="props">
                <span style="font-size:13px;">{{props.item.documentocxc.descripcion}}  </span>
              </template>



<!-- <template v-slot:body.append v-if="windowSize.width >600">
<tr>  
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong class="d-flex justify-end" style="font-size:11px; color: #00838F;">Total de horas:</strong></td>
         
<td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(Totales.totalHora)}} </strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
  </tr>
 </template>
<template v-slot:footer v-if="windowSize.width<=600">
<v-list-item style="font-size: 70%;" class="white--text" > 
      <v-list-item-content>
        <span>Total de horas:{{currencyFormatter(Totales.totalHora)}} </span>
      

      </v-list-item-content>
    </v-list-item>

  </template> -->

 </v-data-table>


  </div>
  </v-col>



  </div>
  </v-card>
  <hr>
<v-card color="grey lighten-3">
  <div class="px-2" style="border: 1px solid #000000;">

<v-form ref="formRecIng2" @submit.prevent=""  v-model="valid" lazy-validation>
  <!-- row 1 -->
<v-row>

     <!------------------------------- COL-1 RECIBO  -->
    <v-col cols="12" md="2" sm="2">
     <!-- RECIBO - FECHA -->
      <v-tooltip top>
    <template v-slot:activator="{ on }"> 
    <v-text-field
            v-on="on"
            dense
            outlined
            type="date"  
            label="Fecha"
            v-model="UtilRecIng.fecha"
            :rules="[$rules.required]"
            placeholder=" "
            style="font-size: 12px;"  
            hide-details   class="py-1"
            >
                    <template v-slot:prepend>
                      <i style="font-size: 18px;" class="fa fa-calendar"></i>
                    </template>
    </v-text-field>
    </template>
    <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
              <span> Se muestra la fecha del recibo.</span>
        </i>   
      </v-tooltip>
     <!-- RECIBO - FECHA -->
     <!-- RECIBO - No.RECIBO -->
    <v-tooltip top>
  <template v-slot:activator="{ on }">  

  <v-text-field v-on="on"
              id="ImputColorDisable"
              label="No.secuencia:"
              type="number"
              disabled
              dense
              autocomplete="off"
              outlined
              v-model.number="UtilRecIng.recibosdeingresoPK.secuencia"
              style="font-size: 13px;"  hide-details class="py-1"
              
            >
              <template v-slot:prepend>
                <i  style="font-size: 20px;" class="fa fa-hashtag"></i>
              </template>
            </v-text-field>
  </template>
  <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
            <span> Se muestra el número de secuencia que se realizó el recibo.</span>
      </i>   
    </v-tooltip>
     <!-- FIN RECIBO - No.RECIBO -->

     <!-- RECIBO - No.CIERRE -->
     <v-tooltip top>
<template v-slot:activator="{ on }">  

<v-text-field v-on="on"
            label="No.Cierre:"
            dense
            autocomplete="off"
            outlined
            :rules="[$rules.required]"
            v-model="UtilRecIng.numerocierre"
            style="font-size: 13px;"
            hide-details class="py-1"
          >
            <template v-slot:prepend>
              <i  style="font-size: 20px;" class="fa fa-hashtag"></i>
            </template>
          </v-text-field>
 </template>
<i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
          <span> Se muestra el número de cierre de caja en el cual se realizó el recibo.</span>
    </i>   
       </v-tooltip>
      <!-- FIN RECIBO - No.CIERRE -->

  <!-- RECIBO - activo -->
   <v-switch
              class="mt-0 py-1"
              v-model="UtilRecIng.activo"
              label="activo"
              color="success"
              hide-detail
              dense
              hide-details 
              >
        <template v-slot:label>
        <strong v-if="UtilRecIng.activo==true"  style="color:#000000; font-size: 13px; ">activo: Si</strong>
        <strong v-if="UtilRecIng.activo==false" style="color:#000000; font-size: 13px; ">activo: No</strong>
        </template>


           
  </v-switch>
      <!-- FIN RECIBO - activo --> 
    </v-col>
     <!------------------------------- FIN COL-1 RECIBO  -->
  

    <!-- ------------------------------ COL-2 RECIBO  --> 
  <v-col cols="12" md="5" sm="5">
    <!-- RECIBO - DOCUMENTO -->
    <v-tooltip top>
    <template v-slot:activator="{ on }"> 
      <v-combobox
          v-on="on"
                v-model="UtilRecIng.documentocxc"
                autocomplete="off"
                id="ImputColorDisable"
                dense
                outlined
                label="Documentos:"
                :items="RDocumento"
                item-text="descripcion"
                style="font-size: 13px;"
                disabled
              hide-details class="py-1"
            
              >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-book"></i>
                </template>
              </v-combobox>

    </template>
    <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
              <span> Se muentra el documento  del recibo de ingreso.</span>
        </i>   
      </v-tooltip>
    <!-- RECIBO - DOCUMENTO -->
      <!-- RECIBO - CLIENTE -->
      <v-tooltip top>
      <template v-slot:activator="{ on }"> 
      
      <v-combobox
                  v-on="on"
                  id="ImputColorDisable"
                  disabled
                  autocomplete="off"
                  dense
                  outlined
                  label="cliente:"
                  :items="RCliente"
                  item-text="nombre"
                  :rules="[$rules.required]"
                  :suffix="clientTel"
                  style="font-size: 13px;"
                
                  v-model="UtilRecIng.cliente"
                  @blur="SelctCbCliente"
                  @change="ClienteSelect"
                  @focus="cargarCliente"
                  @keyup="CbFilcliente"
                  hide-details class="py-1"
                >
                            <template v-slot:prepend>
                              <i style="font-size: 20px;" class="fa fa-user-circle"></i>
                            </template>
                          </v-combobox> 
                          </template>
      <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
                <span> Se muestra el cliente del  recibo.</span>
          </i>   
      </v-tooltip>
    <!-- FIN RECIBO - CLIENTE -->

    <!-- RECIBO - VENDEDOR -->
    <v-tooltip top>
    <template v-slot:activator="{ on }"> 

      <!--------------------------------------------------------------------------@keyup="CbFilvendedor" Vendedor -->
    <v-combobox   v-on="on"
                        v-model="UtilRecIng.vendedor"
                        label="Vendedor:" 
                        id="ImputColorDisable"
                        required
                        outlined
                        dense
                        autocomplete="off"
                        :items="Rvendedor"
                        item-text="codVenDesc"
                        @blur="SelctCbvendedor"
                        :filter="filterComb"
                        @focus="CargarRvendedor"
                        style="font-size: 13px;"
                        hide-details class="py-1"
                      > 
                        <template slot="item" slot-scope="item">
                          <span style="display:none;">{{ item.item.codVenDesc = `${item.item.codigo} - ${item.item.nombre.trim()} ` }}</span>
                              <span  class="fontSize13"><b>{{ item.item.codigo }}</b> - {{ item.item.nombre.trim() }} </span>
                          </template>


              <!-- <template v-slot:prepend-item>
                      <v-row>
                      <v-col cols="6" md="6" > <b style="font-size: 16px;"> Nombre: </b> </v-col>
                      <v-col cols="6" md="6" > <b style="font-size: 16px;">Cédula: </b> </v-col>
                    </v-row>
              </template> -->

      <template v-slot:prepend>
      <i style="font-size: 20px;" class="fa fa-universal-access"></i> 
    </template>   
    </v-combobox>

    </template>
    <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
              <span> Se muestra el vendedor que realizo la venta correspondiente al recibo.</span>
        </i>   
    </v-tooltip>
    <!-- FIN RECIBO - VENDEDOR -->
    <!-- COL TOTAL RETENCION Y ISR  -->
  <v-row no-gutters class="py-1" >
    <v-col cols="12" md="6" sm="6" > 
      <VueAutonumeric label="Total Retención:" dense outlined
      autocomplete="off"
        v-model.number="UtilRecIng.totalRetencion"
        style="font-size: 13px;"
        hide-details>
          <template v-slot:prepend>
            <i style="font-size: 20px;" class="fa fa-money"></i>
          </template>
        </VueAutonumeric>
    </v-col>
    <v-col cols="12" md="6" sm="6" > 
       <VueAutonumeric label="Total ISR:" dense outlined
      autocomplete="off"
        v-model.number="UtilRecIng.totalIsr"
        style="font-size: 13px;"
        hide-details>
          <template v-slot:prepend>
            <i style="font-size: 20px;" class="fa fa-money"></i>
          </template>
        </VueAutonumeric>
    </v-col>
      
  </v-row>
   <!-- FIN COL TOTAL RETENCION Y ISR  -->
  </v-col>
  <!-- ---------------------------------- FIN COL-2 RECIBO  -->

   <!-- ---------------------------------- COL-3 RECIBO  --> 
    <v-col cols="12" md="5" sm="5" > 
  <!-- RECIBO - REFERENCIA -->
    <v-text-field id="formdisabledInput" v-model="UtilRecIng.referencia" 
                                          autocomplete="off" dense
                                          label="No.Referencia" maxlength="20" outlined
                                          hide-details class="py-1">
                              <template v-slot:prepend>
                                <i class="fa fa-map-signs" style="font-size: 20px;"></i>
                              </template>
  </v-text-field>
  <!-- FIN RECIBO - REFERENCIA -->

  <!-- RECIBO - CAJA -->
    <v-tooltip top>
    <template v-slot:activator="{ on }"> 
  <v-combobox v-on="on"
                      v-model="caja"
                      label="caja"
                      required
                      outlined
                      dense
                      autocomplete="off"
                      :items="RCaja"
                      item-text="descripcion"
                      @blur="SelctCbCaja"
                      @focus="cargarCaja"  
                      style="font-size: 13px;"
                      @change="ChangeCaja"
                      hide-details class="py-1" 
                    > 
                            <template v-slot:prepend>
                              <i
                                style="font-size: 20px;"
                                class="fa fa-desktop"
                              ></i>
                            </template>
                          </v-combobox> 
    </template>
      <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
                <span> Se muestra la caja en la cual se hizo el  recibo.</span>
      </i>   
    </v-tooltip>
    <!-- FIN RECIBO - CAJA -->

     <!-- COL TOTAL MONEDA Y TASA  -->
  <v-row no-gutters class="py-1" >
    <v-col cols="12" md="6" sm="6" > 
      
      <v-combobox id="formdisabledInput" v-model="UtilRecIng.moneda" :items="Rmoneda"
                                          :rules="[$rules.required]" autocomplete="off"
                                          dense
                                          item-text="nombrecorto" label="Moneda"
                                          outlined
                                          @blur="SelctCbMoneda" @change="ChangeMonedaTasa" @focus="cargarMoneda"
                                          hide-details
                                          >
                                <template v-slot:prepend>
                                  <i class="fa fa-usd" style="font-size: 20px;"></i>
                                </template>
                              </v-combobox>

    </v-col>
    <v-col cols="12" md="6" sm="6" > 
      

       <VueAutonumeric id="formdisabledInput" v-model.number="UtilRecIng.tasa"
                                              autocomplete="off" dense label="* tasa:"
                                              outlined hide-details>
                                <template v-slot:prepend>
                                  <i class="fa fa-usd" style="font-size: 20px;"></i>
                                </template>
                              </VueAutonumeric>
    </v-col>
      
  </v-row>
     <!-- COL TOTAL MONEDA Y TASA  -->
      <!-- RECIBO - CONCEPTO -->
        <v-tooltip top>
    <template v-slot:activator="{ on }">  
    <v-textarea v-on="on"
                      autocomplete="off"
                        label="Concepto"
                        rows="1"
                        dense
                        outlined
                        v-model="UtilRecIng.concepto"   
                        style="font-size: 13px;"
                        hide-details class="py-1"
                      >
                        <template v-slot:prepend>
                          <i style="font-size: 20px;" class="fa fa-commenting"></i>
                        </template>
    </v-textarea>
    </template>
    <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
              <span> Se muestra el concepto  que se especificó al momento en el que se hizo el recibo.</span>
        </i>   
      </v-tooltip>
    <!-- FIN RECIBO - CONCEPTO -->

     

    </v-col>
   <!-- --------------------------------- FIN COL-3 RECIBO  --> 
    
</v-row>
<!-- row 1 -->


<!-- row 3 -->
<v-row style="margin-top:-10px;">

<v-col cols="12" md="6" sm="6">
    <v-radio-group class="mt-0"  v-model="opcion" row>
                        <!-- <v-row></v-row>
                          <v-col cols="12" md="6"></v-col> -->
                          <!-- <v-col cols="12" md="6"></v-col> -->
                  <v-radio label="Valor Efectivo" color="green darken-3" :value="1"></v-radio>    
                  <v-radio label="Cheque" color="teal lighten-2" :value="2"></v-radio>
                  <v-radio label="Transferencia" color="cyan lighten-2" :value="3"></v-radio>
                  <v-radio label="Tarjeta" color="blue lighten-4" :value="4"></v-radio>
                  <v-radio label="Pago Anticipado" color="blue-grey" :value="5"></v-radio>
                                                 
</v-radio-group>
  </v-col>


<v-col cols="12" md="6" sm="6">
  
<div v-if="opcion==5">
  <!-------------------------------------------------- Valor  @input="sumaValor"v-on:input="getCrear"      -->
<VueAutonumeric label="Pago Anticiapado:" dense outlined
 autocomplete="off"
  v-model.number="UtilRecIng.valorAnticipado"
  
  :rules="[$rules.required]"
  @input="sumaValor"
  style="font-size: 13px;"
  >
    <template v-slot:prepend>
      <i style="font-size: 20px;" class="fa fa-money"></i>
    </template>

    <template v-slot:append-outer>

  <v-tooltip top>
<template v-slot:activator="{ on }"> 
   
<v-btn @click.prevent="dialogBuscarPago=true" v-on="on" color="blue darken-3" fab x-small dark>
<i style="font-size: 20px;" class="fa fa-search"></i>
</v-btn>

 </template>
          <span>Buscar Pago</span>
        </v-tooltip>    
 </template> 


  </VueAutonumeric>
</div>


<v-row style="margin-top:-10px;" >
  <v-col cols="12" md="6" sm="6">
<div v-if="opcion==2 || opcion==3 || opcion==4 ">

<!-------------------------------------------------- Numero-->
<v-text-field label="Numero"
                     dense outlined
                     v-model="UtilRecIng.numCuenta"
                     :rules="[$rules.required]" 
                     :disabled="disableAll"
                     >
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-hashtag"></i> 
                      </template>
                    </v-text-field>
</div>
  </v-col>

  <v-col cols="12" md="6" sm="6">
    <div v-if="opcion==4">
<!------------------------------------------- Banco-->

<v-combobox
                    v-model="UtilRecIng.tarjetaTipo"
                    label="Banco:"
                    required
                    outlined
                    dense
                    :rules="[$rules.required]"
                    autocomplete="off"
                    :items="RBanco"
                    item-text="nombre"
                    @blur="SelctCbBanco"
                    @focus="cargarBanco"
                    :disabled="disableAll"
                   
                  > 
                          <template v-slot:prepend>
                            <i
                              style="font-size: 20px;"
                              class="fa fa-university"
                            ></i>
                          </template>
                        </v-combobox>
</div>

<div v-if="opcion==2 || opcion==3">

<!-------------------------------------------------- banco-->
<v-text-field label="Banco"
                     dense outlined
                     v-model="UtilRecIng.banco" 
                     :rules="[$rules.required]"
                     :disabled="disableAll"
                     >
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-university"></i> 
                      </template>
                    </v-text-field>

</div>
</v-col>
</v-row> 


<v-row style="margin-top:-25px">
  <v-col cols="12" md="4" sm="4" v-if="opcion!=5" >

<div v-if="opcion==1">
  <!-------------------------------------------------- Valor     v-on:input="getCrear"   -->
<VueAutonumeric label="Efectivo:" dense outlined
 autocomplete="off"
  v-model.number="UtilRecIng.efectivo"
  @input="sumaValor"
  :rules="[$rules.required]"
  :disabled="disableAll"
  
  style="font-size: 13px;"
  >
    <template v-slot:prepend>
      <i style="font-size: 20px;" class="fa fa-money"></i>
    </template>
  </VueAutonumeric>
</div>



<div v-if="opcion==2" >
  <!-------------------------------------------------- Valor cheque       v-on:input="getCrear" -->
<VueAutonumeric label="Valor cheque:" dense outlined
 autocomplete="off"
  v-model.number="UtilRecIng.cheque"
  @input="sumaValor"
  :rules="[$rules.required]"
  :disabled="disableAll"
   
   style="font-size: 13px;"
  >
    <template v-slot:prepend>
      <i style="font-size: 20px;" class="fa fa-money"></i>
    </template>
  </VueAutonumeric>
</div>


<div v-if="opcion==3" >
  <!-------------------------------------------------- Valor cheque      v-on:input="getCrear" -->
<VueAutonumeric label="Valor Tranferencia:" dense outlined
 autocomplete="off"
  v-model.number="UtilRecIng.transferencia"
  :rules="[$rules.required]"
  @input="sumaValor"
  :disabled="disableAll"
   
   style="font-size: 13px;"
  >
    <template v-slot:prepend>
      <i style="font-size: 20px;" class="fa fa-money"></i>
    </template>
  </VueAutonumeric>
</div>

<div v-if="opcion==4" >
  <!-------------------------------------------------- Valor cheque             v-on:input="getCrear"  -->
<VueAutonumeric label="Valor Tarjeta:" dense outlined
 autocomplete="off"
  v-model.number="UtilRecIng.tarjeta"
  :rules="[$rules.required]"
  @input="sumaValor"
  :disabled="disableAll"
   
   style="font-size: 13px;"
  >
    <template v-slot:prepend>
      <i style="font-size: 20px;" class="fa fa-money"></i>
    </template>
  </VueAutonumeric>
</div>
  </v-col>

  <v-col cols="12" md="4" sm="4">
    <!-------------------------------------------------- Valor  @input="getCrear"   v-on:blur="getCrear"   -->
<VueAutonumeric label="Descuento:" dense outlined
 autocomplete="off"
  v-model.number="UtilRecIng.descuento"
   
  :disabled="disableAll"
  @input="sumaValor"
  style="font-size: 13px;"
  
  >
    <template v-slot:prepend>
      <i style="font-size: 20px;" class="fa fa-percent"></i>
    </template>
  </VueAutonumeric>
  </v-col>

<v-col cols="12" md="4" sm="4">
<!------------------------------------------- tipo descuento    -->

<v-combobox 
                    v-model="tipoDescuento"
                    label="Tipo de Descuento:"
                    required
                    outlined
                    dense
                    :rules="[$rules.required]"
                    autocomplete="off"
                    :items="RTipo"
                    item-text="descripcion"
                    @blur="SelctCbTipo"
                    @change="ChangeTipDesc"
                    :disabled="disableAll"
                    v-on:change="sumaValor"
                    placeholder=" "
                    style="font-size: 13px;"
                   
                  > 
                          <template v-slot:prepend>
                            <i
                              style="font-size: 20px;"
                              class="fa fa-tag"
                            ></i>
                          </template>
                        </v-combobox>
</v-col>

</v-row>

</v-col>

<!-- <v-col cols="12" md="4" sm="4"> 

<v-tooltip top>
<template v-slot:activator="{ on }"> 

<VueAutonumeric   v-on="on" 

 label="Valor:" dense outlined
 autocomplete="off"
  v-model.number="UtilRecIng.valor"
  :rules="[$rules.required]"
  style="font-size: 13px;"
  
  >
    <template v-slot:prepend>
      <i style="font-size: 20px;" class="fa fa-money"></i>
    </template>
  </VueAutonumeric>

 </template>
<i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
          <span> Se muestra el valor del recibo.</span>
    </i>   
  </v-tooltip>


</v-col> -->
</v-row>
<!-- fin row 3 -->

</v-form>

  <!-- DETALLE RECIBO DE INGRESO-->
 <v-col v-if="listaDetalleRecibo.length>0" class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" style="border: 1px dashed  #616161;">
               <v-card color="grey lighten-3" > 
                  <v-col style="background-color:#BDBDBD; border: 1px solid #000000; " class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                
                    <span :class="`pl-2 d-flex justify-start black--text`">
                      <b>DETALLE RECIBO DE INGRESO</b> 
                      <v-tooltip top>

                      <template v-slot:activator="{ on }"> 
                       <v-btn   v-on="on" class="px-2"  x-small icon color="green" @click="openAgregarRecIngDetalle" >
                      <i class="fa fa-plus-square" style="font-size: 18px;"></i>
                       </v-btn>
                        </template>
          <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
          <span> AGREGAR DETALLE DE RECIBO DE INGRESO</span>
          </i> 
                       </v-tooltip>
                  
                  </span> 
                    
                
                   <!-- <v-btn icon color="pink" >
                    <i icon class="fa fa-search" style="font-size: 18px;"></i>
                   </v-btn>  -->
                

                  </v-col>

                <v-lazy  v-model="isActive"
                  :options="{  threshold: .5 }"
                  min-height="300"
                  transition="fade-transition"
                >

                    <div class="px-2 pt-1 overflow-x-auto" style="border: 1px solid #000000; max-height:300px; height:300px; " >
                      <v-form v-model="valid" ref="formTabDetalleCheque" lazy-validation> 

                    <!-- class="elevation-1" dense -->
                    <!-- { text: 'ID.Reg', value: 'regDoc',width:'auto',sortable:false, class: ['no-gutters black--text'] }, -->

                     <v-data-table id="TbBord" :headers="headersFactPend" :items="listaDetalleRecibo"
                                  :items-per-page="10" dense disabled :loading="loaderTabla"
                                  item-key="indx">

                      <template v-slot:no-data>
                        <v-card-title>FACTURAS PENDIENTES</v-card-title>

                        <v-sheet v-if="tbFacCargar" :color="`grey ${theme.isDark ? 'darken-2' : 'red darken-1'}`"
                                 class="px-3 pt-3 pb-3">
                          <v-skeleton-loader class="mx-auto" max-width="auto" type="card"></v-skeleton-loader>
                        </v-sheet>
                      </template>

<!-- border-top -->
                         <!--------------------------------------------------  fecha  -->
                        <template v-slot:item.nuevaFechaFactura="props">
                          <span style="display:none;">
                            {{ props.item.indx = `${props.item.recibosingresoDetallePK.codigo}-${props.item.recibosingresoDetallePK.secuencia}-${props.item.recibosingresoDetallePK.documento}-${listaDetalleRecibo.indexOf(props.item)}` }}</span>
                    <v-col  class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                      v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item) ,'border-bottom':getBorderColorSelectFactSeguro(props.item) }">
                       
                      <!-- <p style="font-size:13px;">{{ FormatoFecha(props.item.nuevaFechaFactura) }}</p>
                        </v-col> -->
<!-- class="inputMargin colorNombre" -->
                          <v-text-field id="formdisabledInput" :value="FormatoFecha(props.item.nuevaFechaFactura)" disabled
                                      autocomplete="off" dense class="pt-0 mt-0 fontSize12"
                                       style="border:1px solid #CFD8DC;" hide-details label="" single-line >
                        </v-text-field>
                        </v-col> 
                        </template>

  <!-------------------------------------------------- tbid   -->
                        <template v-slot:item.tbid="props">
                           <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                           v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item) ,'border-bottom':getBorderColorSelectFactSeguro(props.item) }">
                      <v-text-field   id="formdisabledInput" 
                      :value="`${props.item.indx}`" 
                      disabled autocomplete="off" dense class="pt-0 mt-0 fontSize12"  style="border:1px solid #CFD8DC;" hide-details  label="" >
                        </v-text-field>

                        </v-col>

                        </template>
                        <!--------------------------------------------------  REFERENCIA  -->

                        <!--------------------------------------------------  FACTURA  -->
                        <template v-slot:item.factura="props">

                          <!-- if(element.hasOwnProperty('facturasventa')){} -->
                           <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                           v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item) ,'border-bottom':getBorderColorSelectFactSeguro(props.item) }">
                          
                           <!-- props.item.facturasventa.facturasventaPK.secuencia -->
                          <!-- <p v-if="props.item.hasOwnProperty('facturasventa') && props.item.facturasventa != null"
                            style="font-size:13px;">
                            {{ props.item.facturasventa.documentoFactura.nombrecorto }}-{{ getSecuenciaFacoCond(props.item.facturasventa) }}
                          </p>
                          <p v-if="props.item.hasOwnProperty('notadebitoclientes') && props.item.notadebitoclientes != null"
                              style="font-size:13px;">
                            {{ props.item.notadebitoclientes.documentocxc.nombrecorto }}-{{props.item.notadebitoclientes.notadebitoclientesPK.secuencia}}
                          </p> -->
                      
                      <v-text-field v-if="props.item.hasOwnProperty('facturasventa') && props.item.facturasventa != null"id="formdisabledInput" 
                      :value="`${props.item.facturasventa.documentoFactura.nombrecorto.trim()}-${getSecuenciaFacoCond(props.item.facturasventa)}`" 
                      disabled autocomplete="off" dense class="pt-0 mt-0 fontSize12"  style="border:1px solid #CFD8DC;" hide-details  label="" >
                        </v-text-field>

                        <v-text-field v-if="props.item.hasOwnProperty('notadebitoclientes') && props.item.notadebitoclientes != null" id="formdisabledInput" 
                        :value="`${props.item.notadebitoclientes.documentocxc.nombrecorto.trim()}-${props.item.notadebitoclientes.notadebitoclientesPK.secuencia}`" 
                        disabled autocomplete="off" dense class="pt-0 mt-0 fontSize12"  style="border:1px solid #CFD8DC;" hide-details  label="" >
                        </v-text-field>
                        </v-col>

                        </template>
                        <!--------------------------------------------------  REFERENCIA  -->

                       <template v-slot:item.facturasventa.referencia="props">
                          <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                           v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item) ,'border-bottom':getBorderColorSelectFactSeguro(props.item) }">

                        <!-- <p v-if="props.item.hasOwnProperty('facturasventa') && props.item.facturasventa != null"
                           style="font-size:13px;">{{ props.item.facturasventa.referencia!=null? props.item.facturasventa.referencia+"." :"." }}</p>
                        <p  v-if="props.item.hasOwnProperty('notadebitoclientes') && props.item.notadebitoclientes != null"
                            style="font-size:13px;">{{ props.item.notadebitoclientes.referencia!=null? props.item.notadebitoclientes.referencia+".":"." }}</p>
                           -->

                        <v-text-field v-if="props.item.hasOwnProperty('facturasventa') && props.item.facturasventa != null" 
                        id="formdisabledInput" :value="props.item.facturasventa.referencia" disabled
                                      autocomplete="off" dense class="pt-0 mt-0 fontSize12"
                                       style="border:1px solid #CFD8DC;" hide-details label="" single-line >
                        </v-text-field>

                        <v-text-field v-if="props.item.hasOwnProperty('notadebitoclientes') && props.item.notadebitoclientes != null" 
                        id="formdisabledInput" :value="props.item.notadebitoclientes.referencia" disabled
                                      autocomplete="off" dense class="pt-0 mt-0 fontSize12"
                                       style="border:1px solid #CFD8DC;" hide-details label="" single-line >
                        </v-text-field>
                        </v-col>

                      </template>
                        <!--------------------------------------------------  valor -->

                      <template v-slot:item.valorr="props">
                        <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                           v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item) ,'border-bottom':getBorderColorSelectFactSeguro(props.item) }">
                           
                        <!-- <p v-if="props.item.hasOwnProperty('facturasventa') && props.item.facturasventa != null"
                           style="font-size:13px;">
                          {{ currencyFormatter(props.item.facturasventa.valor / UtilRecIng.tasa) }}</p>
                        <p
                            v-if="props.item.hasOwnProperty('notadebitoclientes') && props.item.notadebitoclientes != null"
                            style="font-size:13px;">
                          {{ currencyFormatter(props.item.notadebitoclientes.valor / UtilRecIng.tasa) }}</p> -->
                   
                   
                          <v-text-field v-if="props.item.hasOwnProperty('facturasventa') && props.item.facturasventa != null" 
                          id="formdisabledInput" :value="currencyFormatter(props.item.facturasventa.valor / UtilRecIng.tasa)" disabled
                                      autocomplete="off" dense class="pt-0 mt-0 fontSize12"
                                       style="border:1px solid #CFD8DC;" hide-details label="" single-line >
                        </v-text-field>

                        <v-text-field v-if="props.item.hasOwnProperty('notadebitoclientes') && props.item.notadebitoclientes != null" 
                        id="formdisabledInput" :value="currencyFormatter(props.item.notadebitoclientes.valor / UtilRecIng.tasa)" disabled
                                      autocomplete="off" dense class="pt-0 mt-0 fontSize12"
                                       style="border:1px solid #CFD8DC;" hide-details label="" single-line >
                        </v-text-field>

                   
                   
                   
                        </v-col>
                      </template>

                       <!-------------------------------------------------- Tasa -->

                      
                      <template v-slot:item.tasaa="props">
                        <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                           v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item)}">
                        <!-- <p style="font-size:13px;"> {{ currencyFormatter(getTasaFactDetalle(props.item)) }}</p> -->
                   
                        <v-text-field id="formdisabledInput" :value="currencyFormatter(getTasaFactDetalle(props.item))" disabled
                                      autocomplete="off" dense class="pt-0 mt-0 fontSize12"
                                       style="border:1px solid #CFD8DC;" hide-details label="" single-line >
                        </v-text-field>
                   
                      </v-col>
                      </template>

                            <!-------------------------------------------------- pendiente -->
                       <template v-slot:item.pendientedespues="props">
                        <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                           v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item)}">
                        <!-- <p style="font-size:13px;"> {{ currencyFormatter(props.item.pendientedespues) }}</p> -->
                      
                      <v-text-field id="formdisabledInput" :value="currencyFormatter(props.item.pendientedespues)" 
                                      autocomplete="off" dense class="pt-0 mt-0 fontSize12"
                                       style="border:1px solid #CFD8DC;" hide-details label="" single-line >
                        </v-text-field>
                      
                      
                      </v-col>
                      </template>

                        <!-------------------------------------------------- abono -->
                      <template v-slot:item.abono="props">
                           <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                           v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item)}">
                           <!-- <VueAutonumeric id="formdisabledInput" v-model.number="props.item.abono" :disabled="disableAll"
                                        autocomplete="off"
                                        class="inputMargin"
                                        dense outlined
                                        style="font-size:13px;"
                                        @input="calcularTotal(props.item.abono)">
                        </VueAutonumeric> -->
                        <VueAutonumeric id="formdisabledInput" v-model.number="props.item.abono" :disabled="disableAll"
                                        autocomplete="off" 
                                        class="pt-0 mt-0 fontSize12" label=""
                                        dense single-line  style="border:1px solid #CFD8DC;" hide-details
                                        @input="calcularTotal(props.item.abono)"
                                        >
                        </VueAutonumeric>

                      </v-col>

                      </template>
                     
                      
 <!-------------------------------------------------- blurDescuento(props.item.descuento) descuento  v-on:input="sumaValor"  v-on:input="BlurDesc(props.item)"-->
                      <template v-slot:item.descuento="props">
                        <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                           v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item)}">
                      
                           <!-- <VueAutonumeric id="formdisabledInput" v-model.number="props.item.descuento"
                                        :disabled="disableAll" autocomplete="off"
                                        class="inputMargin"
                                        dense outlined
                                        style="font-size:13px;" @blur="blurDescuento(props.item)"
                                        @input="calcularTotal(props.item.descuento)">
                          </VueAutonumeric> -->
                  
                          <VueAutonumeric id="formdisabledInput" v-model.number="props.item.descuento"
                                        :disabled="disableAll" autocomplete="off"
                                        class="pt-0 mt-0 fontSize12" dense single-line hide-details
                                        style="border:1px solid #CFD8DC;" @blur="blurDescuento(props.item)"
                                        @input="calcularTotal(props.item.descuento)">
                          </VueAutonumeric>
                  
                      </v-col>

                      </template>
                     

                       <!--------------------------------------------------  retencion isr -->
                      <template v-slot:item.retencionIsr="props">
<v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                           v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item)}">
                        <!-- <VueAutonumeric id="formdisabledInput" v-model.number="props.item.retencionIsr"
                                        :disabled="disableAll" autocomplete="off"
                                        class="inputMargin"
                                        dense outlined
                                        style="font-size:13px;"
                                        @input="calcularTotal(props.item.retencionIsr)">
                        </VueAutonumeric> -->


                        <VueAutonumeric id="formdisabledInput" v-model.number="props.item.retencionIsr"
                                        :disabled="disableAll" autocomplete="off"
                                        dense class="pt-0 mt-0 fontSize12"
                                         hide-details label="" single-line 
                                        style="border:1px solid #CFD8DC;"
                                        @input="calcularTotal(props.item.retencionIsr)">
                        </VueAutonumeric>
                         </v-col>
                      </template>
                      <!-------------------------------------------------- fn retencion isr -->

                      <!--------------------------------------------------  retencion itb -->
                      <template v-slot:item.retencion="props">
                        <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                           v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item)}">
                        <!-- <VueAutonumeric id="formdisabledInput" v-model.number="props.item.retencion"
                                        :disabled="disableAll" autocomplete="off"
                                        class="inputMargin"
                                        dense outlined
                                        style="font-size:13px;"
                                        @input="calcularTotal(props.item.retencion)">

                        </VueAutonumeric> -->


                        <VueAutonumeric id="formdisabledInput" v-model.number="props.item.retencion"
                                        :disabled="disableAll" autocomplete="off"
                                        class="pt-0 mt-0 fontSize12"
                                        dense single-line hide-details label=""
                                        style="border:1px solid #CFD8DC;"
                                        @input="calcularTotal(props.item.retencion)">

                        </VueAutonumeric>
                        </v-col>
                      </template>
                      <!-------------------------------------------------- fn retencion itb -->

                      <!--------------------------------------------------  fecha de pago -->
                      <template v-slot:item.fechaPago="props">
                        <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                           v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item)}">
                       <!-- <v-text-field id="formdisabledInput" v-model="props.item.fechaPago" :disabled="disableAll"
                                      class="inputMargin colorNombre" dense
                                      outlined style="font-size:13px;" type="date">
                           --<template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-calendar"></i>
                             </template>-- 
                        </v-text-field>-->

                      <v-text-field id="formdisabledInput" v-model="props.item.fechaPago" :disabled="disableAll"
                                      class="pt-0 mt-0 fontSize12" dense hide-details label="" single-line
                                       style="border:1px solid #CFD8DC;" type="date">
                        </v-text-field>
                      </v-col>
                      </template>
                      <!-------------------------------------------------- fn fecha de pago -->

 <!--------------------------------------------------  apagar -->
                      <template v-slot:item.apagar="props">
                        <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                           v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item)}">
                        <!-- <VueAutonumeric id="formdisabledInput" :value="(props.item.abono+props.item.descuento)"
                                        autocomplete="off" class="inputMargin" dense
                                        disabled
                                        outlined style="font-size:13px;"
                                        @input="calcularTotal(props.item.abono)"
                        >
                        </VueAutonumeric> -->

                         <VueAutonumeric id="formdisabledInput" :value="(props.item.abono+props.item.descuento)"
                                        autocomplete="off" class="pt-0 mt-0 fontSize12" dense
                                        disabled  label="" single-line style="border:1px solid #CFD8DC;" hide-details
                                        @input="calcularTotal(props.item.abono)"
                        >
                        </VueAutonumeric>

                        </v-col>
                      </template>
                     
                      <template v-slot:item.balanceTotal="props">
                        <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                           v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item) }">
                       
                           <!-- <p v-if="props.item.balanceTotal >= 0" style="font-size:13px;"> {{ currencyFormatter(props.item.balanceTotal) }}</p>
                        <p v-if="props.item.balanceTotal < 0" style="font-size:13px;"> ( {{ currencyFormatter(props.item.balanceTotal) }} )</p>  -->
                      
                        <v-text-field id="formdisabledInput" :value="props.item.balanceTotal < 0?`(${currencyFormatter(props.item.balanceTotal)})`:currencyFormatter(props.item.balanceTotal)"
                                   disabled autocomplete="off" dense class="pt-0 mt-0 fontSize12"
                                       style="border:1px solid #CFD8DC;" hide-details label="" single-line >
                        </v-text-field>

                        
                      
                      
                      </v-col>

                      


                      </template>

                      <template v-slot:item.acciones="{ item }">

                      <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                           v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(item)}">

                        <v-row no-gutters>
                      <v-col class="pa-0 ma-0 py-0 my-0" cols="6" md="6" sm="6">
                        <v-btn    class="px-2"  x-small icon :color="item.recibosingresoDetallePK.codigo>0&&item.recibosingresoDetallePK.secuencia>0 ? 'blue':'green'" @click="SaveOrUpdateReciboIngresoDetalle(item)" >
                         <i :class="item.recibosingresoDetallePK.codigo>0&&item.recibosingresoDetallePK.secuencia>0 ? 'fa fa-pencil-square':'fa fa-plus-square'" style="font-size: 18px;"></i>
                       </v-btn>
                      </v-col>
                      <!-- notifBorrarDetalleRecIng(JSON.parse(JSON.stringify(item))) -->
                      <v-col class="pa-0 ma-0 py-0 my-0" cols="6" md="6" sm="6">
                        <v-btn  class="px-2"  x-small icon color="red" @click="notifBorrarDetalleRecIng(item)" >
                          <i class="fa fa-trash" style="font-size: 18px;"></i>
                       </v-btn>
                      </v-col>

                        </v-row>
                        </v-col>

                            <!-- <v-btn color="red" rounded small @click="notifBorrarContabilidad(JSON.parse(JSON.stringify(item)))">
                              <i class="fa fa-trash" style="font-size: 20px; "></i>
                            </v-btn> -->
                          </template>
                     
                      <!-- <template v-slot:item.fechafactura="props"> 
                        <p style="font-size:13px;">{{ FormatoFecha(props.item.fechafactura) }}</p>
                      </template>-->

                      
                      <!-- currencyFormatter -->
                      <template v-if="windowSize.width > 600" v-slot:body.append>
                        <tr>
                          <td class="border-top-bottom"><strong></strong></td>
                          <td class="border-top-bottom"><strong></strong></td>
                          <td class="border-top-bottom"><strong class="d-flex justify-end" style="font-size:13px;">Totales:</strong>
                          </td>
                          <!-- <td class="border-top-bottom"  ><strong></strong></td> -->

                          <td class="border-total"><strong class="d-flex justify-center"> </strong></td>
                          <td class="border-total"><strong class="d-flex justify-center" style="font-size:13px;">
                            {{ currencyFormatter(TotalFacRecIng.valor) }} </strong></td>
                            <td class="border-top-bottom"><strong></strong></td>
                          <td class="border-total"><strong class="d-flex justify-center" style="font-size:13px;">
                            {{ currencyFormatter(TotalFacRecIng.pendiente) }} </strong></td>
                          <td class="border-total"><strong class="d-flex justify-center" style="font-size:13px;">
                            {{ currencyFormatter(TotalFacRecIng.abono) }} </strong></td>
                          <td class="border-total"><strong class="d-flex justify-center" style="font-size:13px;">
                            {{ currencyFormatter(TotalFacRecIng.descuento) }} </strong></td>
                          <td class="border-total"><strong class="d-flex justify-center" style="font-size:13px;">
                            {{ currencyFormatter(TotalFacRecIng.itbis) }} </strong></td>
                          <td class="border-total"><strong class="d-flex justify-center" style="font-size:13px;">
                            {{ currencyFormatter(TotalFacRecIng.isr) }} </strong></td>
                          <td class="border-total"><strong class="d-flex justify-center"> </strong></td>
                          <td class="border-total"><strong class="d-flex justify-center" style="font-size:13px;">
                            {{ currencyFormatter(TotalFacRecIng.apagar) }} </strong></td>
                          <td class="border-total"><strong class="d-flex justify-center" style="font-size:13px;">
                            {{ currencyFormatter(TotalFacRecIng.balanceTotal) }} </strong></td>
                            <td class="border-top-bottom"><strong></strong></td>
                            <td class="border-top-bottom"><strong></strong></td>
                            
                        </tr>
                      </template>

                      <template v-if="windowSize.width <= 600" v-slot:footer>
                        <v-list-item class="white--text" style="font-size: 70%;">
                          <v-list-item-content>

                            <span>VALOR: {{ currencyFormatter(TotalFacRecIng.valor) }}</span>
                            <span>PENDIENTE: {{ currencyFormatter(TotalFacRecIng.pendiente) }}</span>
                            <span>ABONO: {{ currencyFormatter(TotalFacRecIng.abono) }}</span>
                            <span>DESCUETO: {{ currencyFormatter(TotalFacRecIng.descuento) }}</span>
                            <span>ITBIS: {{ currencyFormatter(TotalFacRecIng.itbis) }}</span>
                            <span>ISR: {{ currencyFormatter(TotalFacRecIng.isr) }}</span>
                            <span>ISR: {{ currencyFormatter(TotalFacRecIng.apagar) }}</span>
                            <span>BALANCE-TOTAL: {{ currencyFormatter(TotalFacRecIng.balanceTotal) }} </span>

                          </v-list-item-content>
                        </v-list-item>

                      </template>


                    </v-data-table>

                    </v-form>

                    </div>
              </v-lazy>

                  </v-card>
               </v-col>
              <!-- FN DETALLE RECIBO DE INGRESO -->

  </div>
</v-card>



 </div>

        </v-app> 
      </td>
<!-- fn contenido central ------------------------------------------------------------------------------------->
<!-- BarraSecundaria ------------------------------------------------------------------------------------------>
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraSecundariaAprir" >

 <div  class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">
        
<!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
</div>

      </td>
<!-- fn BarraSecundaria --------------------------------------------------------------------------------------->



    </tr>
  </table>
<!-- Modales -------------------------------------------------------------------------------------------------->
  <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      label="myAlert"
      v-model="acti_tb_data"
      persistent
      max-width="100%"
      max-height="100%"
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            fab
            small
            @click="acti_tb_data = !acti_tb_data"
          >
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                @keyup="filtro"
                label="Buscar"
                single-line
                hide-details
              >
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :headers="slotHtabla"
              dense
              :items="list"
              :search="search"
              @click:row=""
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog
      label="myAlert"
      v-model="Elim_notif.estado"
      persistent
      max-width="350"
      transition="fab-transition"
    >
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px;" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px;" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn
            @click.prevent="
              eliminar(), (Elim_notif.estado = !Elim_notif.estado)
            "
            small
          >
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn @click.prevent="Elim_notif.estado = !Elim_notif.estado" small>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      style="margin-top: 20%;"
      :vertical="true"
      :timeout="120000"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>




<v-dialog  v-model="dialogReporte"  persistent fullscreen hide-overlay transition="dialog-bottom-transition" >
  
<v-card>  
    <v-toolbar dark color="grey darken-2">

      <v-tooltip bottom >
<template v-slot:activator="{ on }">

  <v-toolbar-title v-on="on">
            Imprecion de reporte
  </v-toolbar-title>

 </template  >
 <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> 
  <span >  Imprecion: </span> Vista e Imprecion del reporte</i>

  </v-tooltip>

            <!-- <v-toolbar-title>Ordenes De Compras sugeridas</v-toolbar-title> -->

            <v-spacer></v-spacer>


      <v-btn
          color="grey darken-4"
          fab
          small
          @click="NewReporte"
        >
         <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
        </v-btn>
    </v-toolbar>

<v-list three-line subheader>
<pdf-app style="height: 100vh;" :pdf="pdf" :config="config"></pdf-app>

</v-list>
</v-card>
</v-dialog>

<!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog
      label="myAlert"
      v-model="notif.estado"
      persistent
      max-width="350"
      transition="fab-transition"
    >
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px;" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px;" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn
            v-if="notif.Exec='ResFacRecibo'"
            @click.prevent="restaurarFacReciboingreso(), (notif.estado = !notif.estado)"
            small
          >
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn @click.prevent="notif.estado = !notif.estado" small>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

<v-dialog
        v-model="Reparaloading"
        
        persistent
        width="300"
      >
        <v-card
          color="grey darken-2"
          dark
        >
          <v-card-text>
            Espere...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
</v-dialog>


<!-- ------------------------------------------------------ Modal- Agregar detalle rec Ing -->
    <v-dialog v-model="dialogAddReciboDetalle" label="Modal Agregar detalle rec Ing" max-height="95%" max-width="95%"
              persistent transition="fab-transition">
 <div v-if="dialogAddReciboDetalle" >
 <v-toolbar color="#dd4b39" dark dense>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">

              <v-toolbar-title v-on="on"><i class="fa fa-info-circle" style="font-size: 20px;"> </i> 
                FACTURA/NOTA.DEBITO PENDIENTE
              </v-toolbar-title>

            </template>
            <i class="fa fa-info-circle" dark dense style="font-size: 20px;"> <span> FACTURA/NOTA.DEBITO PENDIENTE: </span>
              FACTURA/NOTA.DEBITO PENDIENTE</i>

          </v-tooltip>

          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn-toggle>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="orange" dark small @click="cancelarAddReciboDetalle()" v-on="on">
                    <i class="fa fa-reply-all" style="font-size: 20px;"> </i>
                    CANCELAR
                  </v-btn>
                </template>
                <span>CANCELAR: Retornar </span>
              </v-tooltip>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" color="light-blue darken-4" dark small @click="AddReciboDetalle()"
                         v-on="on">
                    <i class="fa fa-plus" style="font-size: 20px;"></i><!-- fab x-small dark  -->
                    AGREGAR
                  </v-btn>
                </template>
                <span>AGREGAR: AGREGA A LA LISTA</span>
              </v-tooltip>

            </v-btn-toggle>

          </v-card-actions>

          <!-- <v-btn
              color="grey darken-4"
              fab
              small
              @click=""
            >
             <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
            </v-btn> -->
        </v-toolbar>
 <v-card>
 <v-col cols="12" md="12" sm="12" class="pa-0 ma-0 py-0 my-0">
  <!--style="margin-top:-25px;"  -->
<!-- @click:row="datostabla" -->

<v-card>
 
<v-toolbar
        flat
        color="indigo"
        dense
      >
        
<v-card-actions v-if="windowSize.width >600">    
<!-- <v-btn-toggle rounded dense  ></v-btn-toggle> -->
  <v-tooltip v-if="false" top>
<template v-slot:activator="{ on }">
   
<v-btn v-if="false" rounded v-on="on" @click.prevent="NotifMessage" :disabled="UtilRecIng.recibosdeingresoPK.secuencia==0"  color="blue lighten-3" >
<i style="font-size: 20px;" class="fa fa-retweet"></i><!-- fab x-small dark  -->
Restaurar detalle</v-btn>


 </template>
          <span >Restaurar detalle</span>
  </v-tooltip>

<v-tooltip v-if="false"top>
  
<template v-slot:activator="{ on }">

<v-btn rounded  @click.prevent="CargarFactPendiente"  :disabled="UtilRecIng.recibosdeingresoPK.secuencia==0" v-on="on" color="orange lighten-2"  >
<i style="font-size: 20px;" class="fa fa-retweet"></i><!-- fab x-small dark  -->
cargar Fac. Pendiente</v-btn>


 </template>
          <span>cargar Factura Pendiente</span>
</v-tooltip>

<v-tooltip v-if="false" top>
<template v-slot:activator="{ on }">

<v-btn rounded  @click.prevent="GenerarContabilidad" :disabled="GenerarContloading"  v-on="on" color="teal"  >
<i style="font-size: 20px;" class="fa fa-retweet"></i><!-- fab x-small dark  -->
Generar contabilidad</v-btn>


 </template>
          <span>Generar contabilidad</span>
</v-tooltip>

</v-card-actions>  

        <v-spacer></v-spacer>
<!-- <v-card-actions></v-card-actions>  -->
      <v-text-field
        v-model="searchListFac"
        append-icon="mdi-magnify"
        label="Buscar"
        @blur="orgRecSearListfac"
        dense
        outlined
        hide-details
        background-color="#FFFFFF"
        color="#000000"
        rounded
        
      ></v-text-field>
 
</v-toolbar>


<div style="border: 1px solid #000000;" >
<v-data-table 
    :search="searchListFac"
    :single-select="false"
    show-select
    item-key="indxCodigo"
    v-model="selectedAddDetalleRecIng"
      disabled
      id="TbBord"
       
        :headers="[{ sortable: false, text: 'Fecha', value: 'fechafacturaa', width:80, class: ['no-gutters black--text']}, 
        { sortable: false, text: 'Factura', value: 'indxCodigo',width:80, class: ['no-gutters black--text']},
        { sortable: false, text: 'Referencia', value: 'referencia',class: ['no-gutters black--text']},
        { sortable: false, text: 'Valor', value: 'valorr', class: ['no-gutters black--text']},
        {sortable: false, text: 'Pendiente', value: 'pendientedespues',class: ['no-gutters black--text']}]"
        :items="recibosingresoList"
        :items-per-page="10"
        :footer-props="$arrayPropiedasesGlobal"
        dense
      >
    
<template v-slot:no-data>
      <v-card-title>FACTURAS RECIBOS INGRESOS</v-card-title>

      <v-sheet v-if="tbFacCargar"
    :color="`grey ${theme.isDark ? 'darken-2' : 'red darken-1'}`"
    class="px-3 pt-3 pb-3"
  >
    <v-skeleton-loader
      class="mx-auto"
      max-width="auto"
      type="card"
    ></v-skeleton-loader>
  </v-sheet>
</template>

<!--------------------------------------------------  fecha -->
<template v-slot:item.fechafacturaa="props">
<v-col  class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" 
v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item) ,'border-bottom':getBorderColorSelectFactSeguro(props.item) }">

<v-text-field id="formdisabledInput" :value="FormatoFecha(props.item.fechafactura)" disabled
                                      autocomplete="off" dense class="pt-0 mt-0 fontSize12"
                                       style="border:1px solid #CFD8DC;" hide-details label="" single-line >
                        </v-text-field>
</v-col> 

     <span style="font-size:13px;" v-if="props.item.hasOwnProperty('facturasventa')"> <span v-if="props.item.facturasventa!=null">
     <span style="display:none;">{{props.item.indxCodigo =props.item.facturasventa.documentoFactura.nombrecorto.trim()+"-"+props.item.facturasventa.facturasventaPK.secuencia}}</span>
     </span>
     </span>

    <span style="font-size:13px;" v-if="props.item.hasOwnProperty('notadebitoclientes')"> <span v-if="props.item.notadebitoclientes!=null"> 
    <span style="display:none;">{{props.item.indxCodigo =props.item.notadebitoclientes.documentocxc.nombrecorto.trim()+"-"+props.item.notadebitoclientes.notadebitoclientesPK.secuencia}}</span>
    </span>
    </span>

</template>

<template v-slot:item.indxCodigo="props">
    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                           v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item) ,'border-bottom':getBorderColorSelectFactSeguro(props.item) }">
                          
                      <v-text-field v-if="props.item.hasOwnProperty('facturasventa') && props.item.facturasventa != null"id="formdisabledInput" 
                      :value="`${props.item.facturasventa.documentoFactura.nombrecorto.trim()}-${getSecuenciaFacoCond(props.item.facturasventa)}`" 
                      disabled autocomplete="off" dense class="pt-0 mt-0 fontSize12"  style="border:1px solid #CFD8DC;" hide-details  label="" >
                        </v-text-field>

                        <v-text-field v-if="props.item.hasOwnProperty('notadebitoclientes') && props.item.notadebitoclientes != null" id="formdisabledInput" 
                        :value="`${props.item.notadebitoclientes.documentocxc.nombrecorto.trim()}-${props.item.notadebitoclientes.notadebitoclientesPK.secuencia}`" 
                        disabled autocomplete="off" dense class="pt-0 mt-0 fontSize12"  style="border:1px solid #CFD8DC;" hide-details  label="" >
                        </v-text-field>
     </v-col>
</template>

<template v-slot:item.valorr="props">

<v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                           v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item) ,'border-bottom':getBorderColorSelectFactSeguro(props.item) }">
  
                           <v-text-field v-if="props.item.hasOwnProperty('facturasventa') && props.item.facturasventa != null" 
                          id="formdisabledInput" :value="currencyFormatter(props.item.facturasventa.valor / UtilRecIng.tasa)" disabled
                                      autocomplete="off" dense class="pt-0 mt-0 fontSize12"
                                       style="border:1px solid #CFD8DC;" hide-details label="" single-line >
                        </v-text-field>

                        <v-text-field v-if="props.item.hasOwnProperty('notadebitoclientes') && props.item.notadebitoclientes != null" 
                        id="formdisabledInput" :value="currencyFormatter(props.item.notadebitoclientes.valor / UtilRecIng.tasa)" disabled
                                      autocomplete="off" dense class="pt-0 mt-0 fontSize12"
                                       style="border:1px solid #CFD8DC;" hide-details label="" single-line >
                        </v-text-field>
                          </v-col>                       

 </template> 


<template v-slot:item.referencia="props">
<v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                           v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item) ,'border-bottom':getBorderColorSelectFactSeguro(props.item) }">
  
<v-text-field v-if="props.item.hasOwnProperty('facturasventa') && props.item.facturasventa!=null"
id="formdisabledInput" :value="props.item.facturasventa.referencia" disabled
                                      autocomplete="off" dense class="pt-0 mt-0 fontSize12"
                                       style="border:1px solid #CFD8DC;" hide-details label="" single-line >
</v-text-field>

<v-text-field v-if="props.item.hasOwnProperty('notadebitoclientes') && props.item.notadebitoclientes!=null"
id="formdisabledInput" :value="props.item.notadebitoclientes.referencia" disabled
                                      autocomplete="off" dense class="pt-0 mt-0 fontSize12"
                                       style="border:1px solid #CFD8DC;" hide-details label="" single-line >
</v-text-field>


</v-col>                     
</template>


  <template v-slot:item.pendientedespues="props">
                        <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12"
                           v-bind:style="{ 'font-size': '13px;', 'background':getBorderColorSelectFactSeguro(props.item)}">
                        <!-- <p style="font-size:13px;"> {{ currencyFormatter(props.item.pendientedespues) }}</p> -->
                      
                      <v-text-field id="formdisabledInput" :value="currencyFormatter(props.item.pendientedespues)" disabled
                                      autocomplete="off" dense class="pt-0 mt-0 fontSize12"
                                       style="border:1px solid #CFD8DC;" hide-details label="" single-line >
                        </v-text-field>
                      
                      
                      </v-col>
  </template>



<!-- currencyFormatter -->
<template v-slot:body.append v-if="windowSize.width >600" >
<tr> 
  <td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong class="d-flex justify-end" style="font-size:13px;">Totales:</strong></td>
<!-- <td class="border-top-bottom"  ><strong></strong></td> -->

<td class="border-total" ><strong class="d-flex justify-center" style="font-size:13px;"> {{currencyFormatter(TotalFacRecIng.valor)}} </strong></td>
<td class="border-total" ><strong class="d-flex justify-center" style="font-size:13px;">  {{currencyFormatter(TotalFacRecIng.pendiente)}}   </strong></td>
  </tr>
 </template>

<template v-slot:footer v-if="windowSize.width<=600">
<v-list-item style="font-size: 70%;" class="white--text" > 
      <v-list-item-content>
        
        <span>VALOR: {{currencyFormatter(TotalFacRecIng.valor)}}</span>
        <span>PENDIENTE: {{currencyFormatter(TotalFacRecIng.pendiente)}}</span>
      </v-list-item-content>
    </v-list-item>

</template>
</v-data-table>

</div>

 </v-card>



<hr>

<CuentasContables
@CuentasContables="CCuentasContables"
:RLisCuenta="RLisCuenta"
:Total="TotalCuenta"
v-if="false"
/>


</v-col>

 </v-card>

 </div>

               </v-dialog>

<!-- ------------------------------------------------------ Modal- Notificacion Confirmacion Adicional -->
    <v-dialog transition="fab-transition" label="Modal Otros Ingresos" v-model="notifConfAdicional.estado" persistent
      max-width="60%" max-height="85%">

      <!--------------------- Creacion de Otros Ingresos ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

     
        <v-col style="background-color:#dd4b39;" class="pa-2 ma-0 py-1 my-0" cols="12" md="12" sm="12">
            <span style="font-size: 22px;"  :class="`d-flex justify-start white--text`"> <i dense class="fa fa-info-circle"> <b> NOTIFICACIÓN</b></i></span>
         </v-col>
        
        <v-card >
          <!-- style="border: 1px solid #000000;" -->
          <!-- columna informacion  -->
          <v-col style="border: 1px solid #000000;"   class="pa-0 ma-0 py-2 my-0" cols="12" md="12" sm="12" :class="`d-flex justify-center`">
            <center >
            <!-- <h2 class="py-5">  </h2> -->
              <code :class="`black--text`" style=" font-size: 25px;border: 1px solid #000000;">
              <b>{{ notifConfAdicional.nombre }}</b>
              </code>
     
           <v-card-actions :class="`d-flex justify-center`">
             <!--borrarContabilidad(notifConfAdicional.objTemp)  -->
            <v-btn  color="green" v-if="notifConfAdicional.Exec == 'contEliminarRecIndDetalle'"
                @click.prevent="eliminarDeralleRecIng(notifConfAdicional.objTemp)" large>
                <i style="font-size: 20px;" class="fa fa-check"></i> Si
              </v-btn>

              <v-btn  color="red" 
              @click.prevent="cerrarNotificacion" large>
                <i style="font-size: 20px;" class="fa fa-ban"></i> No
              </v-btn>

           </v-card-actions>

          
            </center>
          </v-col>
          <!-- columna informacion  -->

        </v-card>
      </div>

    </v-dialog>
     <!-- ------------------------------------------------------ FIN Modal- Notificacion Confirmacion Adicional  -->
<!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>

<script>
import { EventBus } from "../event-bus";
import BarraBusqueda2 from "../components/BarraBusquedaDinam";
import VueAutonumeric from "../components/AutoNumericNuevo";
import CuentasContables from "@/UtilidadComponents/CuentasContables";
import ContenidoBase from "../components/ContenidoBase"
import {
  currencyFormatter,
  fechaNueva,
  FormatoFecha,
  HoraFormatter,
  RedondeoValor,
  RedondeoValorCantRed,
} from "@/js/Funciones.js"
export default {
inject: ['theme'],
  components: {
    BarraBusqueda2,
    VueAutonumeric,
    CuentasContables,
    ContenidoBase,
    PdfApp: window["pdf-viewer"]
  },


  created() {

  },
  mounted() {
   /* EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    EventBus.$on("UtilitarioRecIngNew", this.new);
    EventBus.$on("UtilitarioRecIngSave", this.save);
    EventBus.$on("UtilitarioRecIngRemove", this.remove);
    EventBus.$on("UtilitarioRecIngAnular", this.remove);
    EventBus.$on("UtilitarioRecIngPrintList", this.imprimirList);
   // EventBus.$on("emitUtilitarioRecIng", this.datostabla);
    EventBus.$on("UtilitarioRecIngRecalcular", this.Recalcular);*/
  //  this.cargarTodo();
   //this.$router.push({ path: "/PageNotPermission" })
    this.cargarCaja()
    this.CargarRvendedor()
    EventBus.$on("onResize", this.onResize);
  },

  data:()=>  ({

loaderTabla:false,
dialogAddReciboDetalle:false,
isActive:false,
searchListFac:'',
Reparaloading:false,
 config: { findbar: false },
 pdf: "",
tbFacCargar:false,

selected:[],

disableAll:false,
dialogReporte:false,
GenerarContloading:false,

      Rmoneda:[],
      Rpropietario:[],
      RSucursal:[],
      RCaja:[],
      RCliente:[],
      RDocumento:[],
      Rvendedor:[],
      RLisCuenta:[],

      RfilVendedor:"nombre",
      clientTel:'',
      

       Totales:{totalHora:0},
ObjAnteRecIng:null,
TotalFacRecIng:{
        valor:0,
        pendiente:0,
        abono:0,
        descuento:0,
        itbis:0,
        isr:0,
        abono:0,
        balanceTotal:0,
        },



       TotalCuenta:{
          credito:0,
          debito:0
        }, 

      RBanco:[],

       RTipo:[
{codigo:1, descripcion:"Valor"},
{codigo:2, descripcion:"Porcentaje"},
],

RPagosAnticipado:[
{p:'Arros', e:'5',c:'200'},
{p:'aguacate', e:'15',c:'100'},
{p:'guineo', e:'25',c:'50'},
{p:'papa', e:'50',c:'80'},
{p:'pera', e:'60',c:'90'}

],

TbTotalItem: 0,
resertPagi:true,

  TbPaginator: {
        page: 1,
        itemsPerPage: 5,
        pageStart: 1,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5,
      },

busquedaRecIng:{
cliente:null,
fechaInicial:new Date().toISOString().substr(0,10),
fechaFinal:new Date().toISOString().substr(0,10),
documento:null,
NoRecibo:0,
},




      
      ListaTiposClientes: [],
      ListItems:[],
      windowSize:{width:"auto", height:"auto"},

      opcion:1,
      tipoDescuento:{codigo:1, descripcion:"Valor"},
      caja:null,

recibosingresoList:[],
contabilidad:null,

      UtilRecIng: {

     
          inicio:new Date().toISOString().substr(0,10),
          final:new Date().toISOString().substr(0,10),

          fecha:new Date().toISOString().substr(0,10),
          documentocxc:null,
          caja:null,
          cliente:null,
          vendedor:null,
          numerocierre:0,
          valor:0,
          concepto:'',
          efectivo:0,
          numCuenta:0,
          tarjetaTipo:null,
          banco:null,
          cheque:0,
          transferencia:0,
          tarjeta:0,
          descuento:0,
          tipoDescuento:1,
          recibosdeingresoPK:{secuencia:0},
          activo:true
        //fechaCreacion: new,
      //  fechaModificacion: "", 
      },
      listaDetalleRecibo:[],
      selectedAddDetalleRecIng:[],
     tbFacCargar: false,
    EstadoBtn: {
      BarraTablaDinamicaAprir: false,
      nuevo: true,
      guardar: false,
      eliminar: false,
      anular: false,
      imprimir: false,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },

    notifConfAdicional: {
      estado: false,
      nombre: "",
      Exec: "",
      objTemp:null
    },

      text: "",
      valid: true,
     BarraPrimariaAbrir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

       headersFactPend: [
        {sortable: false, text: "#Tb-ID", value: "tbid", width: 'auto', class: ["no-gutters black--text"]},
        {sortable: false, text: "Fecha", value: "nuevaFechaFactura", width: 110, class: ["no-gutters black--text"]},
        {sortable: false, text: "Factura", value: "factura", width: 100, class: ["no-gutters black--text"]},
        {sortable: false, text: "Referencia", value: "facturasventa.referencia", class: ["no-gutters black--text"]},
        {sortable: false, text: "Valor", value: "valorr", class: ["no-gutters black--text"]},
        {sortable: false, text: "tasa", value: "tasaa", class: ["no-gutters black--text"]},
        {sortable: false, text: "Pendiente", value: "pendientedespues", sortable: false, class: ["no-gutters black--text"], },
        {sortable: false,  text: "Abono", value: "abono", width: 115, sortable: false, class: ["no-gutters black--text"], },
        {sortable: false, text: "Descuento $", value: "descuento", width: 115, sortable: false, class: ["no-gutters black--text"], },
        {sortable: false, text: "Ret.ITBIS", value: "retencion", width: 111, class: ["no-gutters black--text"]},
        {sortable: false, text: "Ret.ISR", value: "retencionIsr", width: 111, class: ["no-gutters black--text"]},
        {sortable: false, text: "Fecha Pago", value: "fechaPago", width: 75, class: ["no-gutters black--text"]},
        {sortable: false, text: "A Pagar", value: "apagar", width: 115, class: ["no-gutters black--text"]},
        {sortable: false, text: "Balance", value: "balanceTotal",  class: ["no-gutters black--text"], },
        { text: 'Acción', sortable: false, value: 'acciones', width:'auto', width:'auto',class: ['no-gutters black--text']  },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" }
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea anular este registro?"
      },

      aalert: {
        estado: false,
        color: null
      },


      notif: {
        estado: false,
        nombre: "",
        Exec:""
      },
    
    }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
 currencyFormatter,
  fechaNueva,
  FormatoFecha,
  HoraFormatter,
  RedondeoValor,
  RedondeoValorCantRed,
filterComb (item, queryText, itemText) {
        const textOne = item.nombre.toLowerCase()
        const textTwo = item.cedula.toLowerCase()
        const searchText = queryText.toLowerCase()

       // const hasValue = val => val != null ? val : ''
       //const text = hasValue(itemText)
        //const query = hasValue(queryText)

        return textOne.indexOf(searchText) > -1 ||
          textTwo.indexOf(searchText) > -1
  
    },


onResize(e){

// console.log("imprii ")

// console.log(e)
this.windowSize=e


},

    abrirTabla() {
      this.BarraPrimariaAbrir = !this.BarraPrimariaAbrir;

    },
    async cargarTodo() {
      // await this.$axios
      //   .post(
      //     this.$hostname +
      //       this.$hName +
      //       "/services/tipocliente/findalltipoclientes",
      //     {
      //       usuario:JSON.parse(JSON.stringify(this.$user)) 
      //     }
      //   )
      //   .then(res => (this.ListaTiposClientes = res.data))
      //   .catch(error => console.log(error));
    },


obtenerDatoSelect(e){
  //console.log('vvv-obtenerDatoSelect-',e)

  if(e.value==true){
      this.datostablaSelect(e.item)
  }


},


// datostabla(e){
// this.selected=[]
// var _this=this;
// setTimeout(function(){ _this.contdatostabla(e)  }, 500);
// },


 async datostablaSelect(e) {
// console.log('Datos Datos')
// console.log(JSON.stringify(JSON.parse(e.jsonDetalle)))
console.log('Datos Datos-->',e)

this.selected=[]
this.selected.push(JSON.parse(JSON.stringify(e)))


this.contabilidad=null,
this.RLisCuenta=[]



 
//this.UtilRecIng.codigo=e.recibosdeingresoPK.secuencia
//this.form.documento=e.documentocxc  e.fecha.split("T")[0]
var ob=JSON.parse(JSON.stringify(e))
//ob.fecha= new Date(e.fecha).toISOString().substr(0,10);
ob.fecha= ob.nuevaFecha

delete ob["recibosingresoDetalleList"]
this.UtilRecIng =JSON.parse(JSON.stringify(ob)) ;

 this.buscarDetalleRecibo(ob)

      if (e.hasOwnProperty("caja") && e.caja != null && e.caja.hasOwnProperty("codigo")) {
        this.caja = JSON.parse(JSON.stringify(e.caja))
      } else {
        this.caja = null
      }


/*this.RCaja.forEach(element=> {

//console.log("peeeeeeeeeeerooooo")

  if(e.caja==element.codigo){

this.UtilRecIng.caja=element.codigo
this.caja=element
//this.UtilRecIng.caja=element.codigo
//console.log("el elemento")
//console.log(element.codigo)
  }
});*/



if(e.cliente!=null){
this.ClienteSelect(e.cliente)
}

 if (e.vendedor != null) {
    e.vendedor.codVenDesc = `${e.vendedor.codigo} - ${e.vendedor.nombre.trim()} ` 
    this.UtilRecIng.vendedor = e.vendedor
      }


this.Total={
        valor:0,
        pendiente:0,
        abono:0,
        descuento:0,
        itbis:0,
        isr:0,
        abono:0,
        balanceTotal:0,
        }
        
this.TotalCuenta={
          credito:0,
          debito:0

        }


if(e.hasOwnProperty('valorAnticipado')){

if(e.valorAnticipado>0){
this.opcion=5
}else{ this.UtilRecIng.valorAnticipado=0 }
}


if(e.hasOwnProperty('cheque')){
if(e.cheque>0){
this.opcion=2
}else{ this.UtilRecIng.cheque=0 }
}

if(e.hasOwnProperty('transferencia')){

if(e.transferencia>0){
this.opcion=3
}else{this.UtilRecIng.transferencia=0}
}


if(e.hasOwnProperty('tarjeta')){
if(e.tarjeta>0){
this.opcion=4
}else{this.UtilRecIng.tarjeta=0}
}


if(e.hasOwnProperty('efectivo')){

if(e.efectivo>0){
this.opcion=1

}else{this.UtilRecIng.efectivo=0}

}



/*if(e.hasOwnProperty('tipoDescuento')){

this.RTipo.forEach(element => {

if(element.codigo=e.tipoDescuento){

this.tipoDescuento=JSON.parse(JSON.stringify(element))

} 
});

}*/


 if (e.hasOwnProperty("tipoDescuento") && e.tipoDescuento != null) {

        if (e.tipoDescuento == 1) {
          this.tipoDescuento = this.RTipo[0]
        }
        if (e.tipoDescuento == 2) {
          this.tipoDescuento = this.RTipo[1]
        }
      } else {
        this.UtilRecIng.tipoDescuento = 1
        this.tipoDescuento = this.RTipo[0]
      }


//this.recibosingresoList=JSON.parse(JSON.stringify(e.recibosingresoDetalleList))
//this.recibosingresoList=JSON.parse(JSON.stringify(e.recibosingresoDetalleList))



/*var RecIngList=JSON.parse(JSON.stringify(e.recibosingresoDetalleList))
console.log('ver detalle-->',e.recibosingresoDetalleList)
RecIngList.forEach(element => {

if(element.hasOwnProperty('facturasventa')){ if(element.facturasventa==null){ delete element["facturasventa"]}}
if(element.hasOwnProperty('notadebitoclientes')){ if(element.notadebitoclientes==null){ delete element["notadebitoclientes"]}}
  
});


var _this=this;
setTimeout(function(){ 
  _this.recibosingresoList=JSON.parse(JSON.stringify(RecIngList)),
  _this.calcularTotal()



}, 5);*/


return
/*this.$axios.post(this.$hostname+this.$hName+'/services/utilitarioContabilidad/BuscarContabilidad',{ 
  
  usuario:JSON.parse(JSON.stringify(this.$user)),
  documento: e.recibosdeingresoPK.documento,
  secuencia: e.recibosdeingresoPK.secuencia,
  operacion: e.documentocxc.operaciones.codigo
  })
.then(res=>{
if(res.data.toString().length >0){
this.contabilidad=res.data, 
this.RLisCuenta=JSON.parse(JSON.stringify(res.data.contabilidadDetalleList)),
this.calcularTotalcuenta(res.data.contabilidadDetalleList),
obj.contabilidad=JSON.parse(JSON.stringify(this.contabilidad)),
this.ObjAnteRecIng=JSON.stringify(obj)
}

})*/




    },


save(){

   EventBus.$emit("loading", true)

  if(this.$refs.formRecIng2.validate()){
var UtilRecIng =JSON.parse(JSON.stringify(this.UtilRecIng))
var sumaRetencion = this.listaDetalleRecibo.reduce((total, item) => total + item.retencion, 0);
var sumaIsr = this.listaDetalleRecibo.reduce((total, item) => total + item.retencionIsr, 0);

if(UtilRecIng.totalRetencion==0 && sumaRetencion>0 ){
UtilRecIng.totalRetencion=sumaRetencion
}

if(UtilRecIng.totalIsr==0 && sumaIsr>0 ){
UtilRecIng.totalIsr=sumaIsr
}

if(this.tipoDescuento!=null && this.tipoDescuento.hasOwnProperty('codigo')){
UtilRecIng.tipoDescuento = this.tipoDescuento.codigo
}else{
  UtilRecIng.tipoDescuento = this.RTipo[0].codigo
}

this.$axios.post(
              this.$hostname + this.$hName + "/utilitarioRecibosIngresos/SaveOrUpdateReciboIngreso",
              UtilRecIng,
              { headers: this.$store.getters.GetheadersAxios },
            )
            .then((res) => {
             // this.alerta("Dato guardado correctamente", "bien")
               
            var _this = this
                setTimeout(function() {
                  var OBJ_GC={
                        sec:res.data.recibosdeingresoPK.secuencia,
                        doc:res.data.recibosdeingresoPK.documento,
                        ope:res.data.documentocxc.operacion
                        }
            _this.getContabilidad(OBJ_GC)
            _this.alerta("Dato guardado correctamente", "bien")
                }, 900)
            })
            .catch(error => {
             EventBus.$emit("loading", false)
              var MESSAGE = ""
              if (error.response) {
                MESSAGE = error.response.data
                // this.alerta(error.response.data, "error")
              } else if (error.request) {
                MESSAGE = error.request
                // this.alerta(error.request, "error")
              } else {
                MESSAGE = error.message
                // this.alerta(error.message, "error")
              }

              if (MESSAGE.trim().length == 0) {
                MESSAGE = "DATO NO GUARDADO CORRECTAMENTE"
              }

              this.alertaNotf(MESSAGE, "error")
            })



console.log('vvveee-->',UtilRecIng)
  }else{
    this.alerta("Los campos en rojo son requeridos", "error")
  }

  

},


saveAntes() {


if(this.TotalCuenta.credito!=this.TotalCuenta.debito){  
this.alerta("El total de debito y credito no coincide en el asiento contable", "error");
return 0 ;
}



if(this.UtilRecIng.valor<this.TotalFacRecIng.abono){  
this.alerta("El total de abono es mayo al efectivo", "error");
return
}


if (this.$refs.formRecIng.validate()) {
this.Reparaloading=true
var jsn={
UtilRecIng:JSON.parse(JSON.stringify(this.UtilRecIng)),
recibosingresoList:JSON.parse(JSON.stringify(this.recibosingresoList)),
contabilidadList:JSON.parse(JSON.stringify(this.RLisCuenta)),
ObjAnteRecIng:this.ObjAnteRecIng,
contabilidad:this.contabilidad,
usuario:JSON.parse(JSON.stringify(this.$user)),
NombreImprementador:JSON.parse(sessionStorage.getItem("NombreImprementador"))
  }
this.$axios.post(this.$hostname + this.$hName +"/services/utilitarioRecibosIngresos/saveOrUpdateReciboIngresos",
          JSON.parse(JSON.stringify(jsn)))
        .then(res => this.alerta("Dato guardado correctamente!", "bien"))
        .catch(error => this.alerta("Dato no guardado","error"));}else{
this.alerta("Los campos en rojo son requeridos", "error");
}




    },
    remove() {

if(this.UtilRecIng.codigo!=0 && this.UtilRecIng.codigo!=null){

      this.Elim_notif.estado = !this.Elim_notif.estado;
}else{ this.alerta("Seleccione un tipo de cliente para eliminar", "error")}


    },
    eliminar() {

  var jsn={
   datos:JSON.parse(JSON.stringify(this.UtilRecIng)),
   usuario:JSON.parse(JSON.stringify(this.$user)) 
  }

if (this.UtilRecIng.codigo!=0) {
        this.$axios
          .post(
            this.$hostname +
              this.$hName +
              "/services/tipocliente/borradoTipoCliente",
            JSON.parse(JSON.stringify(jsn))
          )
          .then(res => {this.alerta(res.data.mensage, res.data.estado)  })
          .catch(error =>
            this.alerta(
              // "hubo un error , por favor verifique el campo descripcion!"
              "Dato no eliminado",
              "error"
            )
          );
      }


    },
    anular() {
      if (this.Elim_notif.estado) {

var jsn={
   datos:JSON.parse(JSON.stringify(this.UtilRecIng)),
   usuario:JSON.parse(JSON.stringify(this.$user)) 
  }

        this.$axios
          .post(
            this.$hostname +
              this.$hName +
              "/services/tipocliente/removeTipoCliente",
            JSON.parse(JSON.stringify(jsn))
          )
          .then(res => this.alerta("Dato eliminado correctamente!", "bien"))
          .catch(error =>
            this.alerta(
              // "hubo un error , por favor verifique el campo descripcion!"
              "Dato no eliminado",
              "error"
            )
          );
      }
    },
    imprimirList() {







    },
    newwnuevo() {


this.selected=[]
 this.tbFacCargar= false,
   this.ListItems=[],
  this.recibosingresoList=[],
  this.listaDetalleRecibo=[]
this.contabilidad=null,
this.RLisCuenta=[]


      this.TotalFacRecIng={
        valor:0,
        pendiente:0,
        abono:0,
        descuento:0,
        itbis:0,
        isr:0,
        abono:0,
        balanceTotal:0,
        },



       this.TotalCuenta={
          credito:0,
          debito:0
        },

this.UtilRecIng= {

     
          inicio:new Date().toISOString().substr(0,10),
          final:new Date().toISOString().substr(0,10),

          fecha:new Date().toISOString().substr(0,10),
          documentocxc:null,
          caja:null,
          cliente:null,
          vendedor:null,
          numerocierre:0,
          valor:0,
          concepto:'',
          efectivo:0,
          numCuenta:0,
          tarjetaTipo:null,
          banco:null,
          cheque:0,
          transferencia:0,
          tarjeta:0,
          descuento:0,
          tipoDescuento:1,
          recibosdeingresoPK:{secuencia:0},
          activo:true

        //fechaCreacion: new,
      //  fechaModificacion: "", 
      },


this.busquedaRecIng={
cliente:null,
fechaInicial:new Date().toISOString().substr(0,10),
fechaFinal:new Date().toISOString().substr(0,10),
documento:null,
NoRecibo:0

}
this.Reparaloading=false
   EventBus.$emit("loading", false)

      //  EventBus.$emit("actualizaBarraBusqueda2");
    },

NewReporte(){


this.dialogReporte=false


},


imprimiir(){

window.print()

},


Recalcular(){


//this.getPdf()

//this.dialogReporte=true

},

ChangeTipDesc(e){

this.UtilRecIng.tipoDescuento=e.codigo

},

ChangeCaja(e){

this.UtilRecIng.caja=e.codigo

},

orgRecSearListfac(){

//this.searchListFac=""
 

this.recibosingresoList.sort(function (a, b) {

  //a.secuencia=0, b.secuencia=0
  if (a.abono < b.abono ) {
    return 1;
  }
  if (a.abono > b.abono) {
    return -1;
  }
  // a must be equal to b
  return 0;
});



},




 filterTextTbFact (item, queryText, itemText) {

// console.log('Verrrr Verr')
// console.log(item)

return item != null &&
          queryText != null &&
          typeof item === 'string' &&
          item.toString().toLocaleUpperCase().indexOf(queryText) !== -1
      
        // const textOne = item.indxCodigo.toLowerCase()
        // const searchText = queryText.toLowerCase()
        //  return textOne.indexOf(searchText) > -1 
        // if(item.hasOwnProperty('facturasventa') && item.facturasventa!=null){
        // textOne= item.facturasventa.facturasventaPK.secuencia.toLowerCase()
        //   }

      //  const textTwo = textTwo= item.notadebitoclientes.notadebitoclientesPK.secuencia.toLowerCase()
        // if(item.hasOwnProperty('notadebitoclientes') && item.notadebitoclientes!=null){
        // textTwo= item.notadebitoclientes.notadebitoclientesPK.secuencia.toLowerCase()
        //   }

//<span style="font-size:13px;" v-if="props.item.hasOwnProperty('facturasventa')"> <span v-if="props.item.facturasventa!=null">{{props.item.facturasventa.documentoFactura.nombrecorto}}-{{props.item.facturasventa.facturasventaPK.secuencia}}</span></span>
  //  <span style="font-size:13px;" v-if="props.item.hasOwnProperty('notadebitoclientes')"> <span v-if="props.item.notadebitoclientes!=null"> {{props.item.notadebitoclientes.documentocxc.nombrecorto}}-{{props.item.notadebitoclientes.notadebitoclientesPK.secuencia}}</span></span>


        

       // const hasValue = val => val != null ? val : ''
       //const text = hasValue(itemText)
        //const query = hasValue(queryText)


       
  
    },




CargarFactPendiente(){
  
this.recibosingresoList=[]
this.$axios.post(this.$hostname + this.$hName + "/utilitarioRecibosIngresos/CargarFacturaPendiente", 
this.UtilRecIng.cliente, {
          headers: this.$store.getters.GetheadersAxios,
        })
          .then((res) => {
           this.CargaFact(res.data)
          })
          .catch((error) => this.alerta(error, "error"))

},

CargaFact(e){
if(e.Listfactura.length>0){
e.Listfactura.forEach(element => {
var objfat={
abono: 0,
descuento: 0,
facturasventa:JSON.parse(JSON.stringify(element)),
fechaPago: null,
fechafactura:element.nuevaFecha ,
nuevaFechaFactura:element.nuevaFecha ,
ncf: element.ncf,
notadebitoclientes: null,
pendientedespues: element.pendiente,
retencion: 0,
retencionIsr: 0}
this.recibosingresoList.push(objfat)
  
});

}

if(e.ListNotaDebitoCliente.length>0){
 e.ListNotaDebitoCliente.forEach(element => {
var objnota={
abono: 0,
descuento: 0,
facturasventa:null,
fechaPago: null,
fechafactura:element.nuevaFecha,
ncf:element.ncf ,
notadebitoclientes: JSON.parse(JSON.stringify(element)),
pendientedespues: element.pendiente,
retencion: 0,
retencionIsr: 0
}
this.recibosingresoList.push(objnota)
});
}

var _this=this;
setTimeout(function(){ _this.calcularTotal()}, 5);


},


NotifMessage(){
var notif= {
        estado: true,
        nombre: "¿Seguro que desea restaurar los factura Recibos de ingreso?",
        Exec:"ResFacRecibo"
      }

this.Exec_notif(notif)
},


 Exec_notif(e) {

//console.log(e)
this.notif=JSON.parse(JSON.stringify(e))

//this.Elim_notif.estado = !this.Elim_notif.estado;
    },

restaurarFacReciboingreso(){
// console.log('ver ver')
// console.log( JSON.parse(this.UtilRecIng.jsonDetalle))

var restDetall=JSON.parse(this.UtilRecIng.jsonDetalle)

var _this=this;

if(restDetall.length>0){

this.recibosingresoList=[]

restDetall.forEach(element => {
  

this.$axios.post(this.$hostname+this.$hName+'/services/utilitarioRecibosIngresos/BuscarDocSecRestaurarFacRecIng', {
usuario:JSON.parse(JSON.stringify(this.$user)),
datos:JSON.parse(JSON.stringify(element))
})
.then(res=>{  

if(res.data.hasOwnProperty('notadebitoclientes')){
var objnota={
abono: element.abono,
descuento: element.descuento,
facturasventa:null,
fechaPago: null,
fechafactura:res.data.notadebitoclientes.fecha,
ncf:element.ncf ,
notadebitoclientes: JSON.parse(JSON.stringify(res.data.notadebitoclientes)),
pendientedespues: element.pendiente,
retencion: element.retencion,
retencionIsr:element.retencion_isr 
}

this.recibosingresoList.push(objnota)
}



if(res.data.hasOwnProperty('facturasventa')){
var objfat={
abono: element.abono,
descuento: element.descuento,
facturasventa:JSON.parse(JSON.stringify(res.data.facturasventa)),
fechaPago: null,
fechafactura:res.data.facturasventa.fecha ,
ncf: element.ncf,
notadebitoclientes: null,
pendientedespues: element.pendiente,
retencion: element.retencion,
retencionIsr: element.retencion_isr }

this.recibosingresoList.push(objfat)

}

setTimeout(this.calcularTotal,500);



    })
 .catch(error =>{this.alertaNotf("Dato no guardado"+error,"error")});


});



}else{this.alertaNotf("Este recibo de ingreso no posee datos para restaurar"+error,"error")}



},



GenerarContabilidad(){
//Ganerando la contabilidada 

// if(this.UtilitarioContabBusqueda.documento==null){
//   this.alerta("Seleccione un documento", "error") 
//   return 0; 
// }


 var Contb= {
   documento: this.UtilRecIng.documentocxc,
   NoSecuencia:this.UtilRecIng.recibosdeingresoPK.secuencia,
   operacion:this.UtilRecIng.documentocxc.operaciones,
 
      }

var _this=this;
this.$axios.post(this.$hostname+this.$hName+'/services/utilitarioContabilidad/GetContabilidad', {
datos:JSON.parse(JSON.stringify(Contb))
})
.then(res=>{ 

  if(res.data.estado==true){this.alertaNotf("Dato generado correctamente!", "bien")
  setTimeout(function(){ _this.BuscarContabilida()}, 5); 
  }
  if(res.data.estado=="NoExist"){this.alertaNotf("Dato contable no generado (Factura no existe)", "error")}
  if(res.data.estado==false){this.alertaNotf("Dato contable no generado correctamente!", "error")}
  if(res.data.estado=="NoSecDocOp"){this.alerta("El número de secuencia no existe en el documento y operación seleccionada", "error")}
  if(res.data.estado=="NoCodCont"){this.alerta("Este documento no posee codificación contable", "error")}
    })
 .catch(error =>{this.alertaNotf("Dato no guardado"+error,"error")});


},

BuscarContabilida(){

this.$axios.post(this.$hostname+this.$hName+'/services/utilitarioContabilidad/BuscarContabilidad',{ 

  usuario:JSON.parse(JSON.stringify(this.$user)),
  documento: this.UtilRecIng.recibosdeingresoPK.documento,
  secuencia: this.UtilRecIng.recibosdeingresoPK.secuencia,
  operacion: this.UtilRecIng.documentocxc.operaciones.codigo,
  })
.then(res=>{ 
// console.log('Resultado'), 
//  console.log(res.data)
this.contabilidad=res.data,
this.RLisCuenta=JSON.parse(JSON.stringify(res.data.contabilidadDetalleList)),
this.calcularTotalcuenta(res.data.contabilidadDetalleList)
//this.contabilidad=res.data

})

//setTimeout(this.CalcularFact,3);

},


GenerandoDatosFact(e){

this.UtilRecIng=JSON.parse(JSON.stringify(e.UtilRecIng))
this.recibosingresoList=JSON.parse(JSON.stringify(e.recibosingresoList))
this.ObjAnteRecIng=JSON.stringify(e.ObjAnteRecIng)

// console.log('Data Informacion')
// console.log( this.ObjAnteRecIng)

this.calcularTotal()
//calcularTotalcuenta

},

calcularTotalcuenta(e){

  this.TotalCuenta.credito=0
  this.TotalCuenta.debito=0

 if(e.toString().length>0){
this.RLisCuenta.forEach(element => {
this.TotalCuenta.credito += element.credito
this.TotalCuenta.debito += element.debito   
});
}

},


calcularTotal_ANTES(){

  //recibosingresoList

  this.TotalFacRecIng.valor=0
  this.TotalFacRecIng.pendiente=0
  this.TotalFacRecIng.abono=0
  this.TotalFacRecIng.descuento=0
  this.TotalFacRecIng.itbis=0
  this.TotalFacRecIng.isr=0
  this.TotalFacRecIng.balanceTotal=0



 if(this.recibosingresoList.length>0){
this.recibosingresoList.forEach(element => {

//v-if="props.item.hasOwnProperty('facturasventa') && props.item.facturasventa!=null"
//v-if="props.item.hasOwnProperty('notadebitoclientes') && props.item.notadebitoclientes!=null "
if(element.hasOwnProperty('facturasventa') && element.facturasventa!=null ){
this.TotalFacRecIng.valor += element.facturasventa.valor
}

if(element.hasOwnProperty('notadebitoclientes') && element.notadebitoclientes!=null ){
this.TotalFacRecIng.valor += element.notadebitoclientes.valor
}


//this.TotalFacRecIng.valor += element.facturasventa.valor
this.TotalFacRecIng.pendiente += element.pendientedespues
this.TotalFacRecIng.abono += element.abono
this.TotalFacRecIng.descuento += element.descuento
this.TotalFacRecIng.itbis += element.retencion
this.TotalFacRecIng.isr += element.retencionIsr

element.balanceTotal= element.pendientedespues - (element.abono + element.descuento + element.retencion + element.retencionIsr)

this.TotalFacRecIng.balanceTotal+= element.balanceTotal



});
}

},

// Cálculo del total de la tabla.
    async calcularTotal() {

      this.TotalFacRecIng.valor = 0
      this.TotalFacRecIng.pendiente = 0
      this.TotalFacRecIng.abono = 0
      this.TotalFacRecIng.descuento = 0
      this.TotalFacRecIng.itbis = 0
      this.TotalFacRecIng.isr = 0
      this.TotalFacRecIng.balanceTotal = 0
      this.TotalFacRecIng.apagar = 0
      if (this.listaDetalleRecibo.length > 0) {


        //this.listaDetalleRecibo.forEach(element => {
        await Promise.all(this.listaDetalleRecibo.map(async (element) => {

          if (element.retencion == null) {
            element.retencion = 0
          }
          if (element.retencionIsr == null) {
            element.retencionIsr = 0
          }

          if (element.hasOwnProperty("facturasventa") && element.facturasventa != null) {
            this.TotalFacRecIng.valor += element.facturasventa.valor
          }

          if (element.hasOwnProperty("notadebitoclientes") && element.notadebitoclientes != null) {
            this.TotalFacRecIng.valor += element.notadebitoclientes.valor
          }


          //this.TotalFacRecIng.valor += element.facturasventa.valor
          this.TotalFacRecIng.pendiente += element.pendientedespues
          this.TotalFacRecIng.abono += element.abono
          this.TotalFacRecIng.descuento += element.descuento
          this.TotalFacRecIng.itbis += element.retencion
          this.TotalFacRecIng.isr += element.retencionIsr
          this.TotalFacRecIng.apagar += (element.abono + element.descuento)
          var abdesreisr = this.RedondeoValor(element.abono + element.descuento + element.retencion + element.retencionIsr)
          element.balanceTotal = this.RedondeoValor(element.pendientedespues - (abdesreisr))
          this.TotalFacRecIng.balanceTotal += element.balanceTotal


        }))
        // });


      }

    },



sumaValor(){

this.UtilRecIng.valor= this.UtilRecIng.efectivo+this.UtilRecIng.cheque+this.UtilRecIng.transferencia+this.UtilRecIng.tarjeta+this.UtilRecIng.valorAnticipado
var vvalor= this.UtilRecIng.valor
var tdescuento=(this.UtilRecIng.valor*this.UtilRecIng.descuento)/100
var valorDescuento= this.UtilRecIng.valor

if(this.UtilRecIng.valor>=0){


this.UtilRecIng.recibosingresoDetalleList.forEach(element => {

if(element.hasOwnProperty('facturasventa')){

if(element.facturasventa.hasOwnProperty('horaFactura')){

//  data.result.splice(2,1)
//  var keyToDelete = "key1"; var myObj: {"test": {"key1": "value", "key2": "value"}} 
//  delete myObj.test.keyToDelete //would not work.
//console.log("shdafhghg")
//console.log(element.facturasventa.horaFactura)

// var keyToDelete= element.facturasventa.horaFactura
// delete this.UtilRecIng.recibosingresoDetalleList.keyToDelete

delete element.facturasventa["horaFactura"] 
}

}


  // por aquii2

// if(vvalor==0){
// console.log('ennnntroo')
// }

if(vvalor>0 && vvalor !=0){

if(vvalor < element.pendientedespues){
element.abono=vvalor

if(this.UtilRecIng.descuento>0 && this.UtilRecIng.tipoDescuento.codigo==2){

var adc= (element.abono*this.UtilRecIng.descuento)/100


if(adc < tdescuento){
element.descuento=adc
tdescuento-=adc
}else{ 
element.descuento=tdescuento  
tdescuento=0 }

//element.abono= element.abono-element.descuento
vvalor=0

// element.descuento= (element.abono*this.UtilRecIng.descuento)/100
// element.abono= element.abono-element.descuento

// vvalor-=element.abono

}else{
vvalor-=element.pendientedespues
element.descuento=0
}

if(this.UtilRecIng.descuento>0 && this.UtilRecIng.tipoDescuento.codigo==1){
  //  element.abono+=valorDescuento
     element.descuento=this.UtilRecIng.descuento
    
     element.abono=valorDescuento
  //  element.abono=element.abono-this.UtilRecIng.descuento 
}
}



if(vvalor >= element.pendientedespues){
element.abono=element.pendientedespues

if(this.UtilRecIng.descuento>0 && this.UtilRecIng.tipoDescuento.codigo==2){
var adc= (element.abono*this.UtilRecIng.descuento)/100

if(adc < tdescuento){
element.descuento=adc
tdescuento-=adc
}else{ 
element.descuento=tdescuento  
tdescuento=0 }

element.abono= element.abono-element.descuento
vvalor-=element.abono

}else{
vvalor-=element.pendientedespues
element.descuento=0
}

if(this.UtilRecIng.descuento>0 && this.UtilRecIng.tipoDescuento.codigo==1){

   element.descuento=this.UtilRecIng.descuento
   element.abono=element.abono-this.UtilRecIng.descuento
   valorDescuento-= element.abono

   
  
}



}

}

else{
element.abono=0
}


if(element.abono==0){
element.descuento=0
}

});

//this.calcularTotal()
//this.getCrear()

}



},





CCuentasContables(e,t){

//this.acti_Modal_cuenta=b

// this.form.RLisCuenta= JSON.parse(JSON.stringify(e));
// this.form.TotalCuenta=JSON.parse(JSON.stringify(t)) 

this.RLisCuenta= JSON.parse(JSON.stringify(e));
//this.form.RLisCuenta= this.RLisCuenta

 this.TotalCuenta=JSON.parse(JSON.stringify(t)) 

},



getPdf() {
  const pdff =
    "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";

  this.pdf= this.base64ToArrayBuffer(pdff);


},


base64ToArrayBuffer(base64) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
},




resertPaginacion(){
this.resertPagi=false

//console.log('entrando al resert paginacion')

this.TbPaginator.page=1
this.TbPaginator.pageStart=0
this.TbPaginator.pageStop=this.TbPaginator.itemsPerPage

var _this=this;
setTimeout(function(){ _this.resertPagi=true  }, 500);

//setTimeout(this.resertPagi=true,1500);


//console.log('La paginacion')
//console.log(this.TbPaginator)

},



cargarPaginacion(e) {

this.selected=[]
  // console.log('cargarPaginacion')
  //     console.log(e);
       this.TbPaginator = e;

      if (this.TbPaginator.itemsPerPage == -1) {
           this.TbPaginator.itemsPerPage = 15;
         // this.TbPaginator.itemsPerPage.push(15) 

      }

this.getRecIngresos()
   //   this.filtro();

    },

getRecIngresos(){

 if(this.busquedaRecIng.NoRecibo.length==0){this.busquedaRecIng.NoRecibo=0}

if(this.$refs.formRecIng.validate()) {

/*this.$axios.post(this.$hostname + this.$hName + "/services/utilitarioRecibosIngresos/ListRecibosIngresos", 
         {
           // descripcion:"",
            usuario:JSON.parse(JSON.stringify(this.$user)),
            datos:JSON.parse(JSON.stringify(this.busquedaRecIng)),
            PrimerRegistro: this.TbPaginator.pageStart,
            paginacion: this.TbPaginator.page,
            cantidad: this.TbPaginator.itemsPerPage,         
        })
        .then(res => {
          this.TbTotalItem = res.data.TbTotalItem, 
          this.ListItems = res.data.ListRecIngresos
        });*/

/*busquedaRecIng:{
cliente:null,
fechaInicial:new Date().toISOString().substr(0,10),
fechaFinal:new Date().toISOString().substr(0,10),
documento:null,
NoRecibo:0,
},  */ 

 if (this.busquedaRecIng.NoRecibo != null && this.busquedaRecIng.NoRecibo.toString().length == 0) {
        this.busquedaRecIng.NoRecibo = null
      }
      var clie = null
      var doc = null

      if (this.busquedaRecIng.cliente != null) {
        clie = this.busquedaRecIng.cliente.codigo
      }
      if (this.busquedaRecIng.documento != null) {
        doc = this.busquedaRecIng.documento.codigo
      }
      var obj = this.TbPaginator.itemsPerPage + "/" + this.TbPaginator.pageStart + "/" + this.busquedaRecIng.NoRecibo + "/" + clie + "/" + doc + "/" + this.busquedaRecIng.fechaInicial + "/" + this.busquedaRecIng.fechaFinal
      EventBus.$emit("loading", true)
      this.$axios.get(this.$hostname + this.$hName + "/reciboingreos/findListReciboIngresoPlus/" + obj, {headers: this.$store.getters.GetheadersAxios})
          .then(res => {
            this.ListItems = res.data.ListItems, this.TbTotalItem = res.data.TbTotalItem
            EventBus.$emit("loading", false)
          })
           .catch(error => {
            EventBus.$emit("loading", false)
            let msg = ""
            if (error.response) {
              msg = error.response.data
            } else if (error.request) {
              msg = error.request.data
            } else {
              msg = error.message
            }
            this.alerta(error + ": " + msg, "error")

          })
}else{
this.alerta("Los campos en rojo son requeridos", "error");
}




},






SelctCbTipo(){

if (this.form.tipoDescuento == null) {
        this.form.tipoDescuento = "";
      }

      if (this.form.tipoDescuento.codigo == undefined) {
        this.alerta("Seleccione un tipo de descuento", "error");
        this.form.tipoDescuento = "";
        return;
      }

},



cargarBanco(){
this.$axios.post(this.$hostname+this.$hName+'/services/TarjetasCredito/findall', {
  usuario:JSON.parse(JSON.stringify(this.$user)) 
})
.then(res=>( this.RBanco=res.data))

},


SelctCbBanco(){

if(this.UtilRecIng.tarjetaTipo==null){

    this.UtilRecIng.tarjetaTipo=''
  }

if(this.UtilRecIng.tarjetaTipo.codigo==undefined){

this.alerta("Seleccione un Banco", "error");
this.UtilRecIng.tarjetaTipo=''
return
}

},




CargarRvendedor() {

 this.$axios.get(this.$hostname + this.$hName + "/vendedores/findallactiv", {headers: this.$store.getters.GetheadersAxios},
      ).then(res => {
        this.Rvendedor = res.data
      })
    },

SelctCbvendedor() {

      if (this.UtilRecIng.vendedor == null) {
        this.UtilRecIng.vendedor = "";
      }

      if (this.UtilRecIng.vendedor.codigo == undefined) {
        this.alerta("Seleccione un vendedor", "error");
        this.UtilRecIng.vendedor = "";
        return;
      }

    },


CbFilvendedor(e) {

if(e.target.value.length==1){

if(e.target.value.charCodeAt(0)>=97 & e.target.value.charCodeAt(0)<=122 ){



this.RfilVendedor="nombre"


this.CargarRvendedor()

}else{this.RfilVendedor="cedula"}



if(e.target.value.charCodeAt(0)>=48 & e.target.value.charCodeAt(0)<=57 ){
this.CargarRvendedor()

this.RfilVendedor="cedula"

}else{this.RfilVendedor="nombre"}

  //numero 48 a 57
  //letras 97 a 122 

}

      },



cargarCliente(){

this.$axios.get(this.$hostname + this.$hName + "/clientes/findtodo/a/3/25/0", {headers: this.$store.getters.GetheadersAxios})
          .then(res => (this.RCliente = res.data))

},


SelctCbClienteBuscar(){

var _this = this
      setTimeout(function() {
        console.log('verrr--->',_this.busquedaRecIng)
        if (_this.busquedaRecIng.cliente == null) {
          _this.busquedaRecIng.cliente== ""
        }

        if (_this.busquedaRecIng.cliente!=null && !_this.busquedaRecIng.cliente.hasOwnProperty("codigo")) {
          _this.busquedaRecIng.cliente= ""
          _this.busquedaRecIng.cliente= null
          //  _this.alerta("Seleccione un cliente", "error");
          return
        }
      }, 300)
},



SelctCbCliente(){
  if(this.UtilRecIng.cliente==null){

    this.UtilRecIng.cliente=''
  }

if(this.UtilRecIng.cliente.codigo== undefined){

this.alerta("Seleccione un cliente", "error");
this.UtilRecIng.cliente=''
return

}

},


CbFilcliente(e) {
     
if (e.target.value.length >= 0) {
        this.$axios
            .get(
                this.$hostname +
                this.$hName +
                "/clientes/findtodo/" +
                (e.target.value === null || e.target.value.length == 0 ? "A" : e.target.value) +
                "/3/25/0",
                {headers: this.$store.getters.GetheadersAxios},
            )
            .then(res => (this.RCliente = res.data))
      }
      
    },


ClienteSelect(e){

this.telefono=''
this.clientEmail=""

 if(e!=null){
if(e.hasOwnProperty('codigo')){

//this.ObjCliente=e
//this.clientTel='Tel.'+e.cedrnc

this.telefono=e.telefono
this.clientEmail=e.correo

}else{

this.telefono=''
this.clientEmail=""

}
 
  }

},





cargarDocumento(){

 this.$axios.get(this.$hostname + this.$hName + "/documentocxc/findallReciboIngreso", {headers: this.$store.getters.GetheadersAxios})
          .then(res => (this.RDocumento = res.data))

},

SelctCbDocumentoBuscar(){

  
var _this = this
      setTimeout(function() {
        if (_this.busquedaRecIng.documento == null) {
          _this.busquedaRecIng.documento== ""
        }

        if (_this.busquedaRecIng.documento != null && !_this.busquedaRecIng.documento.hasOwnProperty("codigo")) {
          _this.busquedaRecIng.documento= ""
          _this.busquedaRecIng.documento= null
          //  _this.alerta("Seleccione un cliente", "error");
          return
        }
      }, 300)

},


SelctCbDocumento(){

  if(this.UtilRecIng.documento==null){

    this.UtilRecIng.documento=''
  }

if(this.UtilRecIng.documento.codigo== undefined){

this.alerta("Seleccione un documento", "error");
this.UtilRecIng.documento=''
return

}

},



cargarCaja(){
 this.$axios
        .get(this.$hostname + this.$hName + "/cajas/findAllActivos", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.RCaja = res.data))

},

cargarSucursal(){
  this.$axios.get(this.$hostname+this.$hName+'/sucursal/findallActivos/',{headers:this.$store.getters.GetheadersAxios})
.then(res=>( this.RSucursal=res.data))
},



SelctCbSucursal(){

 /*if(this.UtilRecIng.sucursal==null){
    this.UtilRecIng.sucursal=''
  }

if(this.UtilRecIng.sucursal.codigo==undefined){
this.alerta("Seleccione un sucursal", "error");
this.UtilRecIng.sucursal=''
return
}*/

  var _this = this
      setTimeout(function () {
        if (_this.UtilRecIng.sucursal == null) {
          _this.UtilRecIng.sucursal = ""
        }

        if (!_this.UtilRecIng.sucursal.hasOwnProperty("codigo")) {
          _this.alerta("Seleccione un sucursal", "error");
          _this.UtilRecIng.sucursal = ""
          _this.UtilRecIng.sucursal = null
          return
        }
      }, 300)

},


SelctCbCaja(){


    var _this = this
      setTimeout(function () {
        if (_this.caja == null) {
          _this.caja = ""
        }

        if (!_this.caja.hasOwnProperty("codigo")) {
          _this.alerta("Seleccione un caja", "error");
          _this.caja = ""
          _this.caja = null
          return
        }
      }, 300)

// if(this.caja==null){

//     this.caja=''
//   }

// if(this.caja.codigo==undefined){


// this.caja=''
// return

// }

},



alertaNotf(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);
        EventBus.$emit("loading", false)
        //this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = true;
        this.Reparaloading=false
         EventBus.$emit("loading", false)
      }
    },


  BlurDesde() {
      if (this.busquedaRecIng.fechaInicial.toString().length == 0) {
        this.busquedaRecIng.fechaInicial = this.fechaNueva()
      }
    },

    BlurHasta() {
      if (this.busquedaRecIng.fechaFinal.toString().length == 0) {
        this.busquedaRecIng.fechaFinal = this.fechaNueva()
      }
    },

remove(){},imprimirList(){},


async buscarDetalleRecibo(Rec) {

  this.listaDetalleRecibo=[]
  this.$axios.post(this.$hostname + this.$hName + "/reciboingreos/buscarDetalleRecibo",
          Rec, {headers: this.$store.getters.GetheadersAxios})
          .then( async res => {
            var REC_DET=res.data;  
      if (Rec.ncAutomatico == true) {
            await Promise.all(REC_DET.filter((ee) => ee.descuentoInformativoNc > 0).map(async (element) => {
              element.descuento = element.descuentoInformativoNc
            }))
      }

      await Promise.all(REC_DET.map(async (element) => {
        if(element.fechaPago!=null){element.fechaPago = element.nuevaFechaPago}
        element.tasa= Rec.tasa
      }))


      this.listaDetalleRecibo=REC_DET
          //  this.UtilRecIng.recibosingresoDetalleList=REC_DET
           var _this = this
              setTimeout(function () {
                _this.calcularTotal()
              }, 500)

            setTimeout(function () {
                EventBus.$emit("loading", false)
              }, 900)
              


          })
          .catch(error => {
            EventBus.$emit("loading", false)
            let msg = ""
            if (error.response) {
              msg = error.response.data
            } else if (error.request) {
              msg = error.request.data
            } else {
              msg = error.message
            }
            this.alerta(error + ": " + msg, "error")

          })

},


 // Copiando el objeto de la tienda al formulario.
    CargarModenaBaseDefault() {
      var mond = this.$store.getters.GetConfiguracionGeneral.config.monedabase
      this.UtilRecIng.moneda = JSON.parse(JSON.stringify(mond))

      var _this = this
      setTimeout(function () {
        _this.getheadersFactPend()
      }, 500)
    },

    // Hacer una llamada API al servidor y obtener los datos.
    cargarMoneda() {

      this.$axios.get(this.$hostname + this.$hName + "/monedas/findallActivos/", {headers: this.$store.getters.GetheadersAxios})
          .then(res => (this.Rmoneda = res.data))

    },


    // Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbMoneda() {

      if (this.UtilRecIng.moneda == null) {

        this.UtilRecIng.moneda = ""
      }

      if (this.UtilRecIng.moneda.codigo == undefined) {

        this.alerta("Seleccione una moneda", "error")
        this.UtilRecIng.moneda = ""
        return

      }

    },

    // Tomando el valor de la opción seleccionada y asignándolo a la variable tasa.
    ChangeMonedaTasa(e) {

      if (e != null) {
        this.UtilRecIng.tasa = JSON.parse(JSON.stringify(e.tasa))
      }
    },

     // Creación de un encabezado de tabla para una tabla.
    getheadersFactPend() {

      // <i v-if="UtilRecIng.moneda!=null" style="font-size: 11px;">{{UtilRecIng.moneda.nombrecorto}}</i> 
      // <i v-if="UtilRecIng.moneda==null" style="font-size: 11px;"></i>  
      var c = ""
      if (this.UtilRecIng.moneda != null) {
        this.headersFactPend = []
        c = this.UtilRecIng.moneda.nombrecorto

        this.UtilRecIng.efectivo = (this.UtilRecIng.efectivo / this.UtilRecIng.tasa)
        this.UtilRecIng.cheque = (this.UtilRecIng.cheque / this.UtilRecIng.tasa)
        this.UtilRecIng.transferencia = (this.UtilRecIng.transferencia / this.UtilRecIng.tasa)
        this.UtilRecIng.tarjeta = (this.UtilRecIng.tarjeta / this.UtilRecIng.tasa)

      }


      var hfp = [
         {sortable: false, text: "#Tb-ID", value: "tbid", width: 'auto', class: ["no-gutters black--text"]},
        {sortable: false,text: "Fecha",value: "nuevaFechaFactura",width: 80,class: ["no-gutters black--text"]}, 
        {sortable: false,text: "Factura",value: "factura",width: 80, class: ["no-gutters black--text"]}, 
        {sortable: false, text: "Referencia", value: "facturasventa.referencia", class: ["no-gutters black--text"]},
        {sortable: false, text: "Valor(" + c + ")", value: "valorr", class: ["no-gutters black--text"]}, 
        {sortable: false, text: "tasa", value: "tasaa", class: ["no-gutters black--text"]},
        {sortable: false, text: "Pendiente(" + c + ")", value: "pendientedespues",  class: ["no-gutters black--text"]}, 
        {sortable: false, text: "Abono(" + c + ")", value: "abono", width: 115, class: ["no-gutters black--text"]}, 
        {sortable: false, text: "Descuento(" + c + ")", value: "descuento", width: 115,  class: ["no-gutters black--text"] },
        {sortable: false, text: "Ret.ITBIS(" + c + ")", value: "retencion", width: 111,  class: ["no-gutters black--text"]}, 
        {sortable: false, text: "Ret.ISR(" + c + ")", value: "retencionIsr", width: 111, class: ["no-gutters black--text"]}, 
        {sortable: false, text: "Fecha Pago", value: "fechaPago", width: 75, class: ["no-gutters black--text"] }, 
        {sortable: false, text: "A Pagar", value: "apagar", width: 115, class: ["no-gutters black--text"], }, 
        {sortable: false, text: "Balance(" + c + ")",value: "balanceTotal",width: 110, class: ["no-gutters black--text"], },
        {sortable: false, text: 'Acción', sortable: false, value: 'acciones', width:'auto', width:'auto',class: ['no-gutters black--text']  },
      ]

      this.headersFactPend = JSON.parse(JSON.stringify(hfp))


      if (this.UtilRecIng.recibosingresoDetalleList.length > 0) {
        this.UtilRecIng.recibosingresoDetalleList = JSON.parse(JSON.stringify(this.ObjTemRecDetList))
      }


      this.sumaValor()
    },

 getBorderColorSelectFactSeguro(e) {

if(e != null && e.hasOwnProperty('facturasventa') && e.facturasventa != null && e.facturasventa.cobertura>0){
   return "#CE93D8"
}else{
return "transparent"
}

    
},

  loaderTablaCargar(){
      this.loaderTabla=true
var _this=this;
setTimeout(function(){ _this.loaderTabla=false }, 900);
    },


     getSecuenciaFacoCond(e) {
      if (e.hasOwnProperty("conduceSecuencia") && e.conduceSecuencia != null) {
        // return e.conduceSecuencia
        return e.facturasventaPK.secuencia
      } else {
        return e.facturasventaPK.secuencia
      }

    },

     getTasaFactDetalle(e) {
      var TASA = 0

      if (e.hasOwnProperty("facturasventa") && e.facturasventa != null) {
        TASA = e.facturasventa.tasa
      }

      if (e.hasOwnProperty("notadebitoclientes") && e.notadebitoclientes != null) {
        TASA = e.notadebitoclientes.tasa != null ? e.notadebitoclientes.tasa : 0
      }

      return TASA

    },

 blurDescuento(e) {

      var _this = this
      setTimeout(function () {
        if (e.descuento > e.abono) {
          e.descuento = 0
        }

        var DescProFact = 0
        var DESC_MAXPRO_REC = _this.$store.getters.GetConfiguracionGeneral.configCxc.descuentoMaxProReciboingreso

        var ObjProRow = e.facturasventa.facturasventaDetalleList.filter((ee) => ee.productos != null && ee.productos.descuento > 0)
        if (DESC_MAXPRO_REC == true && e.descuento > 0) {
          Promise.all(ObjProRow.map(async (eleObj) => {

            // var TIPO_DESC_GLO_PORC=this.form.tipoDescuento!=null&&this.form.tipoDescuento.codigo==2?true:false
            //var DESCGLO=this.form.recibo.descuento>0?this.form.recibo.descuento:0


            var ITEM_DESC_VALOR = 0
            if (e.facturasventa.tipocomprobante.itbis == false) {
              ITEM_DESC_VALOR = ((eleObj.productos.descuento * (eleObj.precio * eleObj.cantidad)) / 100)
            } else {

              if (eleObj.productos.incluirimpuestoenprecio == true && eleObj.productos.impuesto != null) {
                var pre = (eleObj.precio / (1 + (eleObj.productos.impuesto.tasa / 100)))
                ITEM_DESC_VALOR = ((eleObj.productos.descuento * (pre * eleObj.cantidad)) / 100)

              } else {
                ITEM_DESC_VALOR = ((eleObj.productos.descuento * (eleObj.precio * eleObj.cantidad)) / 100)
              }

            }


            if (e.descuento <= ITEM_DESC_VALOR) {
              DescProFact += e.descuento
            } else {
              DescProFact += ITEM_DESC_VALOR
            }


            // if (eleObj.productos.incluirimpuestoenprecio == true && eleObj.productos.impuesto != null) {
            //      var pre = (eleObj.precio / (1 + (eleObj.productos.impuesto.tasa / 100)))
            //      DescProFact+=((eleObj.productos.descuento * (pre * eleObj.cantidad)) / 100)

            //  } else{
            //   DescProFact+=((eleObj.productos.descuento * (eleObj.precio * eleObj.cantidad)) / 100)
            //  }


          }))

          DescProFact = _this.RedondeoValorCantRed(DescProFact, 4)
          if (e.descuento > DescProFact) {
            e.descuento = JSON.parse(JSON.stringify(DescProFact))
          }
          _this.calcularTotal()
        }


        if (e.descuento > 0) {
        //  _this.getCrear()
        }

      }, 300)
      // this.getCrear
    },

openAgregarRecIngDetalle(){
EventBus.$emit("loading", true)
this.recibosingresoList=[]
this.selectedAddDetalleRecIng=[]
this.$axios.post(this.$hostname + this.$hName + "/utilitarioRecibosIngresos/CargarFacturaPendiente", 
this.UtilRecIng.cliente, {
          headers: this.$store.getters.GetheadersAxios,
        })
          .then((res) => {
            EventBus.$emit("loading", false)
           this.CargaFact(res.data)
           this.dialogAddReciboDetalle=true
          })
          .catch((error) => this.alerta(error, "error"))

},


cancelarAddReciboDetalle(){
this.recibosingresoList=[]
this.selectedAddDetalleRecIng=[]
 this.dialogAddReciboDetalle=false
},

AddReciboDetalle(){

//console.log('this.selectedAddDetalleRecIng-->',this.selectedAddDetalleRecIng) =arraysn2
//console.log('this.listaDetalleRecibo-->',this.listaDetalleRecibo)=arraysn1
//console.log('this.listaDetalleRecibo-->',this.listaDetalleRecibo)
const resultado = this.selectedAddDetalleRecIng.filter(item2 => {
    return !this.listaDetalleRecibo.some(item1 => {
        // Comparar Factura de Venta
        if (item2.facturasventa && item1.facturasventa) {
            return (
                item2.facturasventa.facturasventaPK.documento ===
                    item1.facturasventa.facturasventaPK.documento &&
                item2.facturasventa.facturasventaPK.secuencia ===
                    item1.facturasventa.facturasventaPK.secuencia
            );
        }

        // Comparar Nota de Débito
        if (item2.notadebitoclientes && item1.notadebitoclientes) {
            return (
                item2.notadebitoclientes.notadebitoclientesPK.documento ===
                    item1.notadebitoclientes.notadebitoclientesPK.documento &&
                item2.notadebitoclientes.notadebitoclientesPK.secuencia ===
                    item1.notadebitoclientes.notadebitoclientesPK.secuencia
            );
        }
        return false;
    });
}).map(item => ({...item,recibosingresoDetallePK: { codigo: 0,documento: 0,secuencia: 0} }));

this.listaDetalleRecibo = this.listaDetalleRecibo.concat(resultado)
this.cancelarAddReciboDetalle()
this.loaderTablaCargar()
//console.log('Resultado',resultado);

// recibosingresoDetallePK: { codigo: 0,documento: 0,secuencia: 0}
// ARRAYS_PROD_PRESTADO= ARRAYS_PROD_PRESTADO.map(item => ({...item,recibosingresoDetallePK: { codigo: 0,documento: 0,secuencia: 0} }));


},


notifBorrarDetalleRecIng(item){
 /* console.log('verklk-notifBorrarDetalleRecIng->',item)
   const index = this.listaDetalleRecibo.indexOf(item)
   console.log('index>',index)
  this.listaDetalleRecibo.splice(index, 1)
  this.loaderTablaCargar()
*/
  
//item.recibosingresoDetallePK: codigo: 663, documento: 1, secuencia: 449

if(item.recibosingresoDetallePK.codigo>0 && item.recibosingresoDetallePK.documento>0 && item.recibosingresoDetallePK.secuencia>0){
this.notifConfAdicional= {
      estado: true,
      nombre: `\n¿Desea eliminar el registro \n'Tb-ID:${item.indx.trim()}'?`,
      Exec: "contEliminarRecIndDetalle",
      objTemp: item,
    }
}else{
  
 const index = this.listaDetalleRecibo.indexOf(item)
  this.listaDetalleRecibo.splice(index, 1)
  this.loaderTablaCargar()
}

  
      

    return
      },

eliminarDeralleRecIng(ITEM){
console.log('verklk-notifBorrarDetalleRecIng->',ITEM)
 EventBus.$emit("loading", true)
this.$axios.post(
              this.$hostname + this.$hName + "/utilitarioRecibosIngresos/eliminarReciboIngresoDetalle",
              ITEM,
              { headers: this.$store.getters.GetheadersAxios },
            )
            .then((res) => {

            const index = this.listaDetalleRecibo.indexOf(ITEM)
              this.listaDetalleRecibo.splice(index, 1)
              this.loaderTablaCargar()
              this.alertaNotf("DETALLE ELIMINADO CORRECTAMENTE", "bien")
              this.cancelarAddReciboDetalle()
              this.cerrarNotificacion()
            })
            /* .catch(error => {
              this.ejecucion = true;
              this.loading(false)
            }
            );*/
            .catch(error => {
             EventBus.$emit("loading", false)
              var MESSAGE = ""
              if (error.response) {
                MESSAGE = error.response.data
                // this.alerta(error.response.data, "error")
              } else if (error.request) {
                MESSAGE = error.request
                // this.alerta(error.request, "error")
              } else {
                MESSAGE = error.message
                // this.alerta(error.message, "error")
              }

              if (MESSAGE.trim().length == 0) {
                MESSAGE = "DATO NO GUARDADO CORRECTAMENTE"
              }

              this.alertaNotf(MESSAGE, "error")
            })


},

SaveOrUpdateReciboIngresoDetalle(ITEM){

 EventBus.$emit("loading", true)

var NewItem=JSON.parse(JSON.stringify(ITEM))
console.log('veedfgdfge--->',this.UtilRecIng.recibosdeingresoPK)

if(ITEM.recibosingresoDetallePK.secuencia==0 && ITEM.recibosingresoDetallePK.documento==0 && ITEM.recibosingresoDetallePK.codigo==0){
NewItem.recibosingresoDetallePK.secuencia=this.UtilRecIng.recibosdeingresoPK.secuencia
NewItem.recibosingresoDetallePK.documento=this.UtilRecIng.recibosdeingresoPK.documento
NewItem.ncf=null
NewItem.borrado=false
// indx: "0-0-0-1"
// indxCodigo: "Fcr-587"
}
//{{ props.item.indx = `${props.item.recibosingresoDetallePK.codigo}-${props.item.recibosingresoDetallePK.secuencia}-${props.item.recibosingresoDetallePK.documento}-${listaDetalleRecibo.indexOf(props.item)}` }}
console.log('recibosingresoDetallePK--->',NewItem)
console.log('indexOf--->',this.listaDetalleRecibo.indexOf(ITEM))

this.$axios.post(
              this.$hostname + this.$hName + "/utilitarioRecibosIngresos/SaveOrUpdateReciboIngresoDetalle",
              NewItem,
              { headers: this.$store.getters.GetheadersAxios },
            )
            .then((res) => {
              console.log('veee-->',res.data)
              var REC_ING_DET=res.data
                REC_ING_DET.indx= `${res.data.recibosingresoDetallePK.codigo}-${res.data.recibosingresoDetallePK.secuencia}-${res.data.recibosingresoDetallePK.documento}-${this.listaDetalleRecibo.indexOf(ITEM)}`
                REC_ING_DET.indxCodigo= NewItem.indxCodigo
                REC_ING_DET.fechafactura=NewItem.fechafactura
                REC_ING_DET.nuevaFechaFactura=NewItem.nuevaFechaFactura
               // this.listaDetalleRecibo[this.listaDetalleRecibo.indexOf(ITEM)] = REC_ING_DET;
               // ITEM=REC_ING_DET

const index = this.listaDetalleRecibo.indexOf(ITEM);
if (index !== -1) {
                  var _this=this;
                  setTimeout(function(){ 
                    _this.listaDetalleRecibo.splice(index, 1, REC_ING_DET);
                    _this.loaderTablaCargar()
                    _this.alertaNotf("DETALLE ACTUALIZADO CORRECTAMENTE", "bien")
                  }, 800);
}
      
            })
            .catch(error => {
             EventBus.$emit("loading", false)
              var MESSAGE = ""
              if (error.response) {
                MESSAGE = error.response.data
                // this.alerta(error.response.data, "error")
              } else if (error.request) {
                MESSAGE = error.request
                // this.alerta(error.request, "error")
              } else {
                MESSAGE = error.message
                // this.alerta(error.message, "error")
              }

              if (MESSAGE.trim().length == 0) {
                MESSAGE = "DATO NO GUARDADO CORRECTAMENTE"
              }

              this.alertaNotf(MESSAGE, "error")
            })



},


cerrarNotificacion(){
this.notifConfAdicional= {
      estado: false,
      nombre: "",
      Exec: "",
      objTemp:null
    }
},


// Hacer una llamada API al servidor y obtener los datos.
    cargarMoneda() {

      this.$axios.get(this.$hostname + this.$hName + "/monedas/findallActivos/", {headers: this.$store.getters.GetheadersAxios})
          .then(res => (this.Rmoneda = res.data))

    },
 // Tomando el valor de la opción seleccionada y asignándolo a la variable tasa.
    ChangeMonedaTasa(e) {

      if (e != null) {
        this.UtilRecIng.tasa = JSON.parse(JSON.stringify(e.tasa))
      }
    },

SelctCbMoneda(){
var _this = this
      setTimeout(function() {
        if (_this.UtilRecIng.moneda == null) {
          _this.UtilRecIng.moneda== ""
        }

        if (_this.UtilRecIng.moneda != null && !_this.UtilRecIng.moneda.hasOwnProperty("codigo")) {
          _this.UtilRecIng.moneda= ""
          _this.UtilRecIng.moneda= null
          //  _this.alerta("Seleccione un cliente", "error");
          return
        }
      }, 300)

},

getContabilidad(OBJ_GC){
EventBus.$emit("loading", true) 
 this.$axios.post(
        this.$hostname + this.$hName + "/utilitarioContabilidad/GetContabilidad",
        OBJ_GC,
        { headers: this.$store.getters.GetheadersAxios },)
        .then((res) => {
          EventBus.$emit("loading", false) 
       /* if(res.data.length>0){
           var _this = this
            setTimeout(function() {
              //_this.alerta("Dato generado correctamente!", "bien2")
            }, 300)
          
         }else{
            this.alerta("Este documento no posee codificacion contable", "error")
         }*/
        })
        .catch((error) => {
          EventBus.$emit("loading", false) 
         /* if (error.response) {
            this.alerta(error.response.request.responseText, "error")
          } else {  this.alerta(error, "error") }*/
        })

},
    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = false;
        this.Reparaloading=false
           EventBus.$emit("loading", false)
      }
    },




KeyUpCantidad(e){


//  if(e.key.charCodeAt(0)>=48 & e.key.charCodeAt(0)<=57 ){}

if(e.target.value.length==0){

e.target.value=0

}


  if(e.key){

     var mynumeral = require('numeral')
     e.target.value  = mynumeral(e.target.value).value()
     
     //console.log(mynumeral(""+this.mensajero.metadeenvios)).value()
     if(e.target.value==null){

        e.target.value=0
     }

    }
    else{

      e.key=""

     //console.log("no se puede poner letras o signos")
    }


if(e.target.value.length==0){

        e.target.value=0
        e.key=0
     }
    

    
},


    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() {
      // await this.$axios
      //   .post(this.$hostname + this.$hName + "/services/tipocliente/findalltipoclientes", {
      //     usuario:JSON.parse(JSON.stringify(this.$user)) 
      //   })
      //   .then(res => {
      //     this.list = res.data;
      //   });
    }
  },

computed:{

    ActDescBtn(){

      if(this.UtilRecIng.recibosdeingresoPK.secuencia > 0) {

          this.EstadoBtn = {
            BarraTablaDinamicaAprir: false,
            nuevo: true,
            guardar: true,
            eliminar: false,
            anular: false,
            imprimir: false,
            vercuenta: false,
            guardartemporal: false,
            restaurartemporal: false,
            importarDato: false,
            cargarProducto: false,
            ImprimirproductoInv: false,
          }

          if (this.UtilRecIng.activo == false) {
            this.EstadoBtn.vercuenta = false
            this.EstadoBtn.guardar = false
            this.EstadoBtn.anular = false
          } else {
            this.EstadoBtn.vercuenta = false
          }

          if (this.UtilRecIng.hasOwnProperty("depositado") && this.UtilRecIng.depositado != null && this.UtilRecIng.depositado == true) {
            this.EstadoBtn.guardar = false
            this.EstadoBtn.anular = false
          }


        }

        if(this.UtilRecIng.recibosdeingresoPK.secuencia <= 0) {

          this.EstadoBtn = {
            BarraTablaDinamicaAprir: true,
            nuevo: true,
            guardar: false,
            eliminar: false,
            anular: false,
            imprimir: false,
            vercuenta: false,
            guardartemporal: false,
            restaurartemporal: false,
            importarDato: false,
            cargarProducto: false,
            ImprimirproductoInv: false,
          }
        }

/*if(this.UtilRecIng.recibosdeingresoPK.secuencia>0){
  var objjct = {
      save: true,
      eliminar: false,
      anular: false,
      nuevo: true,
      imprimir: false,
      vercuenta:false, 
      btnBarraDi:false,
      recalcular:false,
      imprimirPro:false
    };

}


if(this.UtilRecIng.recibosdeingresoPK.secuencia<=0){

this.disableInp=false

var objjct = {
      save: false,
      eliminar: false,
      anular: false,
      nuevo: true,
      imprimir: false,
      vercuenta:false, 
      btnBarraDi:false,
      recalcular:false,
      imprimirPro:false
    };


}
     
EventBus.$emit("ActDesaBotones", objjct);

if(this.RLisCuenta.length==0){
this.GenerarContloading=false
}else{this.GenerarContloading=true}

if(this.RLisCuenta.length==0){


if(this.UtilRecIng.recibosdeingresoPK.secuencia>0){
this.GenerarContloading=false
}else{this.GenerarContloading=true}


}else{this.GenerarContloading=true}*/


    }
  }







};
</script>

<style>

#ImputColorDisable{
  color:black;
}



</style>
